<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @del="delall" @exps="exp" @imp="imp" @save="save"
                    ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs v-model="act" @tab-click="handleClick">
                    <el-tab-pane :label="$t('getapi[2696]')" name="0"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2697]')" name="1"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1604]')" name="2"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2698]')" name="3"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2699]')" name="4"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2700]')" name="5"></el-tab-pane>
                </el-tabs>
                <div class="btnnowrap" style="margin-top: 2px" v-if="act==1">
                    <el-button type="primary"  :disabled="!btn_batch_release" size="mini" @click="SalBatchCoRelease()" >{{ $t('getapi[3056]') }}</el-button>
                </div>
                <!-- 表格 -->
                <wTable
                        :data="datajson"
                        :loading="loading"
                        queryData="SALCOHeaderViewInfo"
                        :filter_language="['StatusName','direct_move_flag']"
                        :filter_thousandth="['Delivery_Leadtime','AmountSUM','Amount_netSUM','Tax_AmountSUM']"
                        :filter_date="['Delivery_date']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                ></wTable>
                <!-- 表格 -->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <!-- 编辑弹框 -->
                <div class="btnnowrap">
                    <!-- <el-button type="primary" size="mini" @click.native="implist" :disabled="!btn.orderimp">
                        从已有订单导入
                    </el-button> -->
                    <!--<el-button type="primary" size="mini" :disabled="!btn.execl">从Excel导入</el-button>
                    <el-button type="primary" size="mini" :disabled="!btn.imptemplate">获得导入模板</el-button>-->
                    <el-button type="primary" size="mini" @click.native="audit" :disabled="!btn.audit">{{(formInline.Head.Director_Flag == '' || formInline.Head.Director_Flag == 0)?$t('getapi[6473]'):$t('getapi[6474]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mini_xd" :disabled="!btn.release">{{$t('getapi[1488]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mini_cancelxd" :disabled="btn.cancelrelease">{{$t('getapi[6741]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="vismini_qrgb" :disabled="!btn.close">{{$t('getapi[2763]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="force(0)" v-if="false">{{$t('getapi[6475]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="force(1)" v-if="false">{{$t('getapi[6476]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="force(2)" v-if="false">{{$t('getapi[6477]')}}</el-button>
                </div>
                <div style="width:1000px;min-width: 1000px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[1596]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input class="mcolor" v-model="formInline.Head.customer_order"
                                          :placeholder="$t('getapi[1596]')" size="mini"
                                          :readonly="!isEdit" :class="{'readO':!isEdit}"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2583]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <routejump :urlNo="31" v-show="editf && formInline.CoLists.length == 0">
                                <el-input
                                        v-model="formInline.Head.customer_id"
                                        :placeholder="$t('getapi[2583]')"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="formInline.Head.customer_id" :placeholder="$t('getapi[2583]')"
                                          v-show="!editf || formInline.CoLists.length != 0" :readonly="true" class="readO" size="mini"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2584]') }}</span></td>
                            <td colspan="3" style="width:320px;min-width:320px">
                                <el-input v-model="formInline.Head.customer_name" :placeholder="$t('getapi[2584]')" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[3475]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input
                                        :value="$t('getapi[2314]')"
                                        v-show="formInline.Head.consignment_flag == 0"
                                        :placeholder="$t('getapi[3475]')"
                                        :readonly="true" class="readO"
                                        size="mini"
                                ></el-input>
                                <el-input
                                        :value="$t('getapi[6478]')"
                                        v-show="formInline.Head.consignment_flag == 1"
                                        :placeholder="$t('getapi[3475]')"
                                        :readonly="true" class="readO"
                                        size="mini"
                                ></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[2598]') }}</span></td>
                            <td>
                                <routejump :urlNo="6" v-show="editf">
                                <el-input
                                        v-model="formInline.Head.salesman"
                                        :placeholder="$t('getapi[2598]')"
                                        readonly
                                        size="mini"
                                        class="mcolor"
                                >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="peop"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="formInline.Head.salesman" :placeholder="$t('getapi[2598]')" v-show="!editf"
                                           size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[1601]') }}</span></td>
                            <td>
                                <el-date-picker
                                        class="mcolor"
                                        v-model="formInline.Head.delivery_date"
                                        format="yyyy/MM/dd"
                                        value-format="yyyy/MM/dd"
                                        size="mini"
                                        style="width: 100%"
                                        :placeholder="$t('getapi[4121]')"
                                ></el-date-picker>
                            </td>
                            <td><span>{{ $t('getapi[2693]') }}</span></td>
                            <td colspan="3"><el-input v-model="formInline.Head.contract_info" :placeholder="$t('getapi[2693]')"
                                           size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[552]') }}</span></td>
                            <td>
                                <el-input :value="expStatus(formInline.Head.status)" :placeholder="$t('getapi[552]')" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[1338]') }}</span></td>
                            <td><el-input v-model="formInline.Head.currency_code_id" :placeholder="$t('getapi[1338]')" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[3693]') }}</span></td>
                            <td><el-input v-model="formInline.Head.tax_code" :placeholder="$t('getapi[3693]')" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[1225]') }}</span></td>
                            <td style="width:120px;min-width: 120px"><el-input v-model="formInline.Head.tax_rate" :placeholder="$t('getapi[1225]')" :readonly="true" class="readO"
                                           size="mini"></el-input></td>
                            <td colspan="2" style="width:200px;min-width: 200px">
                                <el-checkbox disabled v-if="false" v-model="formInline.Head.issue_part_flow" :true-label="1"
                                             :false-label="0" style="margin-left: 5px">
                                    {{ $t('getapi[2284]') }}
                                </el-checkbox>
                                <el-checkbox v-if="false" v-model="formInline.Head.direct_move_flag" disabled :true-label="1"
                                             :false-label="0">{{ $t('getapi[2592]') }}
                                </el-checkbox>
                                <el-input v-if="false" v-model="formInline.Head.moving_pos" :placeholder="$t('getapi[2593]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-checkbox v-model="formInline.Head.issue_part_flow" :true-label=1 :false-label=0
                                             style="margin-left: 5px">{{ $t('getapi[2284]') }}
                                </el-checkbox>
                                <el-checkbox v-model="formInline.Head.direct_move_flag" :true-label=1 :false-label=0
                                             style="margin-left: 5px" disabled>{{ $t('getapi[2592]') }}
                                </el-checkbox>
                            </td>
                            <td><span>{{$t('getapi[2593]')}}</span></td>
                            <td><el-input v-model="formInline.Head.moving_pos" :placeholder="$t('getapi[2593]')" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[135]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.Head.create_time" :placeholder="$t('getapi[135]')" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[410]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.Head.create_person" :placeholder="$t('getapi[410]')" :readonly="true" class="readO"
                                           size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[732]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.Head.audit_time" :placeholder="$t('getapi[732]')" :readonly="true" class="readO"
                                           size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[4043]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.Head.audit_person" :placeholder="$t('getapi[4043]')" :readonly="true" class="readO"
                                           size="mini"></el-input>
                            </td>
                            <td colspan="2">
                                <el-checkbox v-model="formInline.Head.sale_issue_type" :true-label="0" :false-label="1"
                                              :disabled="formInline.Head.status == 1">{{ $t('getapi[2613]') }}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{$t('getapi[4211]')}}</span></td>
                            <td colspan="3">
                                <el-input  v-model="formInline.Head.closereason" :placeholder="$t('getapi[4211]')" :readonly="true" class="readO"
                                           size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[12783]') }}</span></td>
                            <td>
                                <routejump :urlNo="36">
                                <el-select
                                    filterable
                                    popper-class="select-option"
                                    :disabled="formInline.Head.Order_status == 1 ? true : false"
                                    v-model="formInline.Head.pro_dept"
                                    size="mini"
                            >
                                <el-option v-for="item in DeptList" :key="item.Code" :label="item.Name"
                                           :value="item.Name"></el-option>
                            </el-select>
                                </routejump></td>
                            <td colspan="2" style="width:200px;min-width: 200px"><el-checkbox  v-model="formInline.Head.after_flag" :true-label=1
                                              :false-label=0 :disabled="!editf || formInline.CoLists.length > 0">{{ $t('getapi[13429]') }}</el-checkbox></td>
                            <td><span>{{$t('getapi[13525]')}}</span></td>
                            <td>
                                <el-select filterable v-model="formInline.Head.baseprice_flag"  size="mini" :disabled="!editf || formInline.CoLists.length > 0">
                                    <el-option :label="$t('getapi[1352]')" :value=0></el-option>
                                    <el-option :label="$t('getapi[1292]')" :value=1></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="10">
                                <el-divider content-position="center">{{$t('getapi[6479]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[6470]') }}</span></td>
                            <td><el-input v-model="formInline.Head.Director_Flag_Name" :placeholder="$t('getapi[6470]')" :readonly="true" class="readO"
                                           size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[550]') }}</span></td>
                            <td><el-input v-model="formInline.Head.Director_Person" :placeholder="$t('getapi[550]')" :readonly="true" class="readO"
                                           size="mini"></el-input></td>
                            <td><span>{{$t('getapi[732]')}}</span></td>
                            <td><el-input v-model="formInline.Head.Director_Time" :placeholder="$t('getapi[732]')" :readonly="true" class="readO"
                                           size="mini"></el-input></td>
                        </tr>
                    </table>
                </div>
                <!--<div class="bbl">
                    <span>{{ $t('getapi[1596]') }}</span>
                    <el-input class="mcolor" v-model="formInline.Head.customer_order"
                              :placeholder="$t('getapi[1596]')" style="width: 140px" size="mini"
                              :readonly="!isEdit" :class="{'readO':!isEdit}"></el-input>
                    <span>{{ $t('getapi[2583]') }}</span>
                    <el-input
                            v-model="formInline.Head.customer_id"
                            :placeholder="$t('getapi[2583]')"
                            v-show="editf"
                            style="width: 140px"
                            readonly
                            class="mcolor"
                            size="mini"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>
                    </el-input>
                    <el-input v-model="formInline.Head.customer_id" :placeholder="$t('getapi[2583]')"
                              v-show="!editf" :readonly="true" class="readO" style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[2584]') }}</span>
                    <el-input v-model="formInline.Head.customer_name" :placeholder="$t('getapi[2584]')" :readonly="true" class="readO"
                              style="width: 250px" size="mini"></el-input>

                    <span>{{ $t('getapi[3475]') }}</span>
                    <el-input
                            :value="$t('getapi[2314]')"
                            v-show="formInline.Head.consignment_flag == 0"
                            :placeholder="$t('getapi[3475]')"
                            :readonly="true" class="readO"
                            style="width: 100px"
                            size="mini"
                    ></el-input>
                    <el-input
                            :value="$t('getapi[6478]')"
                            v-show="formInline.Head.consignment_flag == 1"
                            :placeholder="$t('getapi[3475]')"
                            :readonly="true" class="readO"
                            style="width: 140px"
                            size="mini"
                    ></el-input>
                </div>
                <div class="bbl">
                    <span>{{ $t('getapi[2598]') }}</span>
                    <el-input
                            v-model="formInline.Head.salesman"
                            :placeholder="$t('getapi[2598]')"
                            v-show="editf"
                            style="width: 140px"
                            readonly
                            size="mini"
                            class="mcolor"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="peop"></i>
                    </el-input>
                    <el-input v-model="formInline.Head.salesman" :placeholder="$t('getapi[2598]')" v-show="!editf"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[4121]') }}</span>
                    <el-date-picker
                            class="mcolor"
                            v-model="formInline.Head.delivery_date"
                            format="yyyy/MM/dd"
                            value-format="yyyy/MM/dd"
                            size="mini"
                            style="width: 140px"
                            :placeholder="$t('getapi[4121]')"
                    ></el-date-picker>
                    &lt;!&ndash; <el-input v-model="formInline.Head.delivery_date" :placeholder="$t('getapi[4121]')" disabled style="width: 120px;" size="mini"></el-input> &ndash;&gt;
                    <span>{{ $t('getapi[2693]') }}</span>
                    <el-input v-model="formInline.Head.contract_info" :placeholder="$t('getapi[2693]')"
                              style="width: 250px" size="mini"></el-input>
                    <span>{{ $t('getapi[552]') }}</span>
                    <el-input :value="expStatus(formInline.Head.status)" :placeholder="$t('getapi[552]')" :readonly="true" class="readO"
                              style="width: 100px;" size="mini"></el-input>
                </div>
                <div class="bbl">
                    <span>{{ $t('getapi[1338]') }}</span>
                    <el-input v-model="formInline.Head.currency_code_id" :placeholder="$t('getapi[1338]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[3693]') }}</span>
                    <el-input v-model="formInline.Head.tax_code" :placeholder="$t('getapi[3693]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[1225]') }}</span>
                    <el-input v-model="formInline.Head.tax_rate" :placeholder="$t('getapi[1225]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <el-checkbox disabled v-if="false" v-model="formInline.Head.issue_part_flow" :true-label="1"
                                 :false-label="0" style="margin-left: 10px">
                        {{ $t('getapi[2284]') }}
                    </el-checkbox>
                    <el-checkbox v-if="false" v-model="formInline.Head.direct_move_flag" disabled :true-label="1"
                                 :false-label="0">{{ $t('getapi[2592]') }}
                    </el-checkbox>
                    &lt;!&ndash; <span>{{ $t('getapi[2593]') }}</span> &ndash;&gt;
                    <el-input v-if="false" v-model="formInline.Head.moving_pos" :placeholder="$t('getapi[2593]')"
                              style="width: 100px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-checkbox v-model="formInline.Head.issue_part_flow" :true-label=1 :false-label=0
                                 style="margin-left: 20px">{{ $t('getapi[2284]') }}
                    </el-checkbox>
                    <el-checkbox v-model="formInline.Head.direct_move_flag" :true-label=1 :false-label=0
                                 style="margin-left: 20px" disabled>{{ $t('getapi[2592]') }}
                    </el-checkbox>
                    <span>{{$t('getapi[2593]')}}</span>
                    <el-input v-model="formInline.Head.moving_pos" :placeholder="$t('getapi[2593]')" :readonly="true" class="readO" style="width: 140px"
                              size="mini"></el-input>
                </div>
                <div class="bbl">
                    <span>{{ $t('getapi[135]') }}</span>
                    <el-input v-model="formInline.Head.create_time" :placeholder="$t('getapi[135]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[410]') }}</span>
                    <el-input v-model="formInline.Head.create_person" :placeholder="$t('getapi[410]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[732]') }}</span>
                    <el-input v-model="formInline.Head.audit_time" :placeholder="$t('getapi[732]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[4043]') }}</span>
                    <el-input v-model="formInline.Head.audit_person" :placeholder="$t('getapi[4043]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <el-checkbox v-model="formInline.Head.sale_issue_type" :true-label="0" :false-label="1"
                                 style="margin-left: 20px" :disabled="formInline.Head.status == 1">{{ $t('getapi[2613]') }}
                    </el-checkbox>
                </div>
                <div class="bbl">
                    <span>{{$t('getapi[4211]')}}</span>
                    <el-input  v-model="formInline.Head.closereason" :placeholder="$t('getapi[4211]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                </div>
                <div>
                    <el-divider content-position="center">{{$t('getapi[6479]')}}</el-divider>
                </div>
                <div class="bbl">
                    <span>{{ $t('getapi[550]') }}</span>
                    <el-input v-model="formInline.Head.Director_Flag_Name" :placeholder="$t('getapi[135]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{ $t('getapi[4044]') }}</span>
                    <el-input v-model="formInline.Head.Director_Person" :placeholder="$t('getapi[410]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                    <span>{{$t('getapi[732]')}}</span>
                    <el-input v-model="formInline.Head.Director_Time" :placeholder="$t('getapi[732]')" :readonly="true" class="readO"
                              style="width: 140px" size="mini"></el-input>
                </div>-->
                <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[1625]')" name="0">
                        <div>
                            <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="showwcenter('')"
                                       v-if="btn.rowadd">{{$t('getapi[6480]')}}
                            </el-button>
                            <el-button type="primary" size="mini" icon="el-icon-delete-solid" @click="dellines_list"
                                       v-if="btn.rowdel">{{$t('getapi[40]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click.native="vislinetap()" v-if="btn.rowclose">{{$t('getapi[2757]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click.native="linetap(2)" v-if="false">{{$t('getapi[2708]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click.native="linetap(3)" v-if="false">{{$t('getapi[2709]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click.native="linetap(1)" v-if="btn.rowrelease">{{$t('getapi[3085]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click.native="linetap(5)" v-if="btn.rowDongJie">{{$t('getapi[555]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click.native="linetap(6)" v-if="btn.rowJieDong">{{$t('getapi[591]')}}
                            </el-button>
                        </div>
                        <div id="xdetilpane-0">
                            <vxe-table
                                    :data="formInline.CoLists"
                                    header-row-class-name="headerclass"
                                    @checkbox-change="linedelsel"
                                    :row-class-name="tableRowClassNameNot"
                                    border
                                    :height="tableHeight - 310"
                                    resizable
                                    show-overflow="tooltip"
                                    size="mini"
                                    style="width: 100%; margin-top:3px"
                                    @sort-change="sortChange"
                                    :default-sort="sortRule"
                                    :row-key="true"
                                    ref="singleTable1"
                            >
                                <vxe-table-column type="checkbox" align="center" width="30"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_no" :title="$t('getapi[1425]')"
                                                  align="right" width="80" sortable></vxe-table-column>
                                <vxe-table-column field="freeze_flag" :title="$t('getapi[555]')" sortable
                                                  width="60">
                                    <template slot-scope="scope">
                                        {{ scope.row.freeze_flag == 0 ? $t('getapi[866]') : $t('getapi[2052]')}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="statusname" :title="$t('getapi[552]')" sortable
                                                  width="80">
                                    <template slot-scope="scope">
                                        {{scope.row.statusname | lanchange}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="sales_part" :title="$t('getapi[2652]')" sortable
                                                  width="120">
                                </vxe-table-column>
                                <vxe-table-column field="part_name" :title="$t('getapi[2653]')" sortable
                                                  width="100"></vxe-table-column>
                                <vxe-table-column field="isestimateprice" :title="$t('getapi[10314]')" sortable
                                                  align="left" width="80">
                                    <template slot-scope="scope">
                                        {{scope.row.isestimateprice == 0?$t('getapi[2053]'):$t('getapi[2052]')}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="cust_version" :title="$t('getapi[6352]')" sortable width="80">
                                    <template slot-scope="scope">
                                        <el-input class="mcolor" v-model="scope.row.cust_version" :placeholder="$t('getapi[6352]')"
                                                  size="mini" :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0) && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="model" :title="$t('getapi[124]')" sortable
                                                  width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="xcust_version" :title="$t('getapi[6482]')" sortable align="left"
                                                  width="120"></vxe-table-column>
                                <vxe-table-column field="customer_Amount" :title="$t('getapi[12597]')" sortable width="80">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.customer_Amount" :placeholder="$t('getapi[12597]')"
                                                  type="number"  autocomplete="off" title="" size="mini"
                                                  :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0)  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="spec" :title="$t('getapi[4187]')" sortable align="right"
                                                  width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="page_no" :title="$t('getapi[133]')" sortable align="right"
                                                  width="80"></vxe-table-column>
                                <vxe-table-column field="sales_qty" :title="$t('getapi[2715]')" sortable
                                                  align="right" width="80">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.sales_qty" :placeholder="$t('getapi[2715]')"
                                                  type="number" autocomplete="off" title="" @mousewheel.native.prevent @input="detailSum(scope, 0)" size="mini"
                                                  :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0)  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="sales_unit" :title="$t('getapi[2658]')" sortable
                                                  width="100"></vxe-table-column>
                                <vxe-table-column field="price_withtax" :title="$t('getapi[3958]')" sortable
                                                  align="right" width="100" v-if="authority_showprice" key="0">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.price_withtax" :placeholder="$t('getapi[3958]')"
                                                  type="number" autocomplete="off" title="" @mousewheel.native.prevent @input="detailSum(scope, 1)"
                                                  size="mini" :disabled="(formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0))  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1) || !authority_pricecanedit"
                                        ></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="price_net" :title="$t('getapi[1303]')" sortable
                                                  align="right" width="100" v-if="authority_showprice" key="1">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.price_net" :placeholder="$t('getapi[1303]')"
                                                  type="number" autocomplete="off" title="" @mousewheel.native.prevent @input="detailSum(scope, 2)" size="mini"
                                                  :disabled="(formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0))  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1) || !authority_pricecanedit"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="tax_amount" :title="$t('getapi[1611]')" sortable
                                                  align="right" width="80" v-if="authority_showprice" key="2"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="amount" :title="$t('getapi[2102]')" sortable
                                                  align="right" width="80" v-if="authority_showprice" key="3"></vxe-table-column>
                                <vxe-table-column field="package" :title="$t('getapi[3417]')" sortable
                                                  width="100">
                                    <template slot-scope="scope">
                                        <el-select filterable v-model="scope.row.package" size="mini">
                                            <el-option v-for="item in Package" :label="item.TypeName"
                                                       :value="item.TypeName" :key="item.TypeName"></el-option>
                                        </el-select>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="plan_delivery_date" :title="$t('getapi[2694]')" sortable align="right"
                                                  width="100">
                                    <template slot-scope="scope">
                                        <el-date-picker
                                                v-model="scope.row.plan_delivery_date"
                                                type="date"
                                                format="yyyy-MM-dd"
                                                size="mini"
                                                @change="getdatatime(scope,1)"
                                                :placeholder="$t('getapi[2694]')"
                                                :disabled="formInline.Head.status == 4"
                                        ></el-date-picker>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="commit_delivery_date" :title="$t('getapi[2704]')" sortable align="right"
                                                  width="100">
                                    <template slot-scope="scope">
                                        <el-date-picker
                                                v-model="scope.row.commit_delivery_date"
                                                format="yyyy-MM-dd"
                                                size="mini"
                                                :placeholder="$t('getapi[2704]')"
                                                @change="getdatatime(scope,2)"
                                                :disabled="formInline.Head.status == 4"
                                        ></el-date-picker>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="actual_delivery_date"
                                                  :title="$t('getapi[2705]')" sortable align="right" width="100"></vxe-table-column>
                                <vxe-table-column field="cuspart_id" :title="$t('getapi[2390]')" sortable
                                                  align="right" width="80">
                                    <template slot-scope="scope">
                                        <!--<el-input v-model="scope.row.cuspart_id" :placeholder="$t('getapi[2390]')"
                                                  size="mini" :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0)  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input>-->
                                        <el-input v-model="scope.row.cuspart_id" :placeholder="$t('getapi[2390]')"
                                                  size="mini"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="cuspart_name" :title="$t('getapi[2391]')" sortable width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.cuspart_name" :placeholder="$t('getapi[2391]')"
                                                  size="mini"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="remark" :title="$t('getapi[7963]')" sortable
                                                  align="right" width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.remark" :placeholder="$t('getapi[7963]')" size="mini"
                                                  :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0)  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="remark1" :title="$t('getapi[2720]')" sortable
                                                  align="right" width="80">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.remark1" :placeholder="$t('getapi[2720]')" size="mini"></el-input>
                                        <!-- :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0)  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input> -->
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="remark2" :title="$t('getapi[7962]')" sortable
                                                  align="right" width="80">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.remark2" :placeholder="$t('getapi[7962]')" size="mini"
                                                  :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0)  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="exchange_rate" :title="$t('getapi[3599]')" sortable
                                                  align="right" width="80"></vxe-table-column>
                                <vxe-table-column field="customer_item" :title="$t('getapi[2707]')" sortable
                                                  align="right" width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.customer_item" :placeholder="$t('getapi[2707]')" size="mini"></el-input>
                                        <!-- size="mini" :disabled="formInline.Head.status != 0 && !(formInline.Head.status != 4 && scope.row.exclusively_id == 0)  && !((scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3) && scope.row.freeze_flag == 1)"></el-input> -->
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="modify_person" :title="$t('getapi[733]')" sortable
                                                  align="left" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="kmr" :title="$t('getapi[2723]')" sortable align="right"
                                                  width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="modify_time" :title="$t('getapi[1210]')" sortable
                                                  align="left" width="80"></vxe-table-column>
                                <vxe-table-column field="freeze_flag" :title="$t('getapi[2722]')" sortable
                                                  align="left" width="80">
                                    <template slot-scope="scope">
                                        {{scope.row.freeze_flag == 0?$t('getapi[2053]'):$t('getapi[2052]')}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="trace" :title="$t('getapi[6481]')" sortable align="left"
                                                  width="80">
                                    <template slot-scope="scope">
                                        {{scope.row.trace == 0?$t('getapi[2053]'):$t('getapi[2052]')}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" sortable align="left"
                                                  width="80"></vxe-table-column>

                                <vxe-table-column show-footer-overflow field="closereason" :title="$t('getapi[1633]')" sortable align="left"
                                                  width="150"></vxe-table-column>
                                <vxe-table-column field="itemvernum" :title="$t('getapi[6700]')" sortable align="left"
                                                  width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.itemvernum" :placeholder="$t('getapi[6700]')" size="mini" ></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="cus_chartnum" :title="$t('getapi[8595]')" sortable align="left"
                                                  width="150"></vxe-table-column>
                                <vxe-table-column field="notes" :title="$t('getapi[8960]')" sortable align="left"
                                                  width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.notes" size="mini" ></el-input>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </div>
                        <div style="width:920px;margin-top: 3px">
                            <table>
                                <tr>
                                    <td style="width:80px">
                                        <span>{{ $t('getapi[1641]') }}</span>
                                    </td>
                                    <td style="width:150px">
                                        <el-input v-model="formInline.list.BenWei"  :placeholder="$t('getapi[1641]')" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent disabled v-if="authority_showprice"></el-input>
                                        <el-input v-model="formInline.list.BenWei" type="password"  size="mini" :readonly="true" class="readO" v-if="!authority_showprice"></el-input>
                                    </td>
                                    <td style="width:80px">
                                        <span>{{ $t('getapi[1643]') }}</span>
                                    </td>
                                    <td style="width:150px">
                                        <el-input v-model="formInline.list.Amount_netSUM" :placeholder="$t('getapi[1643]')" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  size="mini" :readonly="true" class="readO" v-if="authority_showprice"></el-input>
                                        <el-input v-model="formInline.list.Amount_netSUM" type="password"  size="mini"
                                                  :readonly="true" class="readO" v-if="!authority_showprice"></el-input>
                                    </td>
                                    <td style="width:80px">
                                        <span>{{ $t('getapi[1611]') }}</span>
                                    </td>
                                    <td style="width:150px">
                                        <el-input v-model="formInline.list.Tax_AmountSUM" :placeholder="$t('getapi[1611]')" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  size="mini" :readonly="true" class="readO" v-if="authority_showprice"></el-input>
                                        <el-input v-model="formInline.list.Tax_AmountSUM" type="password"  size="mini"
                                                  :readonly="true" class="readO" v-if="!authority_showprice"></el-input>
                                    </td>
                                    <td style="width:80px">
                                        <span>{{ $t('getapi[1642]') }}</span>
                                    </td>
                                    <td style="width:150px">
                                        <el-input v-model="formInline.list.AmountSUM" :placeholder="$t('getapi[1642]')" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  :readonly="true" class="readO" v-if="authority_showprice"></el-input>
                                        <el-input v-model="formInline.list.AmountSUM" type="password"  size="mini"
                                                  :readonly="true" class="readO" v-if="!authority_showprice"></el-input>
                                    </td>
                                    <td style="width:100px">
                                        <span>{{ $t('getapi[12599]') }}</span>
                                    </td>
                                    <td style="width:150px">
                                        <el-input v-model="formInline.list.Cus_AmountSUM" :placeholder="$t('getapi[12599]')" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  :readonly="true" class="readO" v-if="authority_showprice"></el-input>
                                        <el-input v-model="formInline.list.Cus_AmountSUM" type="password"  size="mini"
                                                  :readonly="true" class="readO" v-if="!authority_showprice"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2724]')" name="1">
                        <div style="width:600px;min-width: 600px">
                            <table>
                                <tr>
                                    <td style="width:80px;min-width: 80px"><span>{{$t('getapi[1116]')}}</span></td>
                                    <td style="width:120px;min-width: 120px">
                                        <routejump :urlNo="37">
                                        <el-select filterable v-model="formInline.Head.delivery_term"
                                                   size="mini">
                                            <el-option
                                                    v-for="item in DeliveryTermList"
                                                    :label="item.Delivery_Term"
                                                    :value="item.Exclusively_ID"
                                                    :key="item.Exclusively_ID"
                                            ></el-option>
                                        </el-select>
                                        </routejump>
                                    </td>
                                    <td style="width:80px;min-width: 80px"><span>{{$t('getapi[1217]')}}</span></td>
                                    <td style="width:120px;min-width: 120px">
                                        <routejump :urlNo="38">
                                        <el-select filterable v-model="formInline.Head.transport_type"
                                                   size="mini">
                                            <el-option v-for="item in TransMode" :label="item.TypeName" :value="item.TypeName"
                                                       :key="item.Exclusively_Id"></el-option>
                                        </el-select>
                                        </routejump>
                                    </td>
                                    <td style="width:80px;min-width: 80px"><span>{{$t('getapi[7931]')}}</span></td>
                                    <td style="width:120px;min-width: 120px">
                                        <el-select filterable v-model="formInline.Head.Address_ShortName_Id" @change="getShortNameInfo"
                                                   size="mini">
                                            <el-option v-for="item in AddressShort" :label="item.Address_ShortName" :value="item.exclusively_id"
                                                       :key="item.exclusively_id"></el-option>
                                        </el-select>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>{{$t('getapi[2596]')}}</span></td>
                                    <td><el-input v-model="formInline.Head.delivery_contract" :placeholder="$t('getapi[2596]')" type="text"
                                                   size="mini"></el-input></td>
                                    <td><span>{{$t('getapi[2614]')}}</span></td>
                                    <td><el-input v-model="formInline.Head.delivery_phone" :placeholder="$t('getapi[2614]')" type="text"
                                                   size="mini"></el-input></td>
                                    <td><span>{{$t('getapi[3597]')}}</span></td>
                                    <td><el-input v-model="formInline.Head.delivery_leadtime" :placeholder="$t('getapi[3597]')" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  style="width: 100px" size="mini"></el-input>
                                        {{$t('getapi[217]')}}</td>
                                </tr>
                                <tr>
                                    <td><span>{{$t('getapi[2595]')}}</span></td>
                                    <td colspan="5"><el-input v-model="formInline.Head.delivery_address" :placeholder="$t('getapi[2595]')" size="mini"></el-input></td>
                                </tr>
                                <tr>
                                    <td><span>{{$t('getapi[2615]')}}</span></td>
                                    <td colspan="5"><el-input type="textarea" v-model="formInline.Head.remark" :placeholder="$t('getapi[2615]')"></el-input></td>
                                </tr>
                            </table>
                        </div>
                        <!--<div class="box">
                            <div class="bbl">
                                <span>{{$t('getapi[1116]')}}</span>
                                <el-select filterable v-model="formInline.Head.delivery_term" style="width: 120px"
                                           size="mini">
                                    <el-option
                                            v-for="item in DeliveryTermList"
                                            :label="item.Delivery_Term"
                                            :value="item.Exclusively_ID"
                                            :key="item.Exclusively_ID"
                                    ></el-option>
                                </el-select>
                                <span>{{$t('getapi[1217]')}}</span>
                                <el-select filterable v-model="formInline.Head.transport_type" style="width: 120px"
                                           size="mini">
                                    <el-option v-for="item in TransMode" :label="item.TypeName" :value="item.TypeName"
                                               :key="item.Exclusively_Id"></el-option>
                                </el-select>
                                <span>{{$t('getapi[7931]')}}</span>
                                <el-select filterable v-model="formInline.Head.Address_ShortName_Id" style="width: 120px" @change="getShortNameInfo"
                                           size="mini">
                                    <el-option v-for="item in AddressShort" :label="item.Address_ShortName" :value="item.exclusively_id"
                                               :key="item.exclusively_id"></el-option>
                                </el-select>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[2596]')}}</span>
                                <el-input v-model="formInline.Head.delivery_contract" :placeholder="$t('getapi[2596]')" type="text"
                                          style="width: 120px" size="mini"></el-input>
                                <span>{{$t('getapi[2614]')}}</span>
                                <el-input v-model="formInline.Head.delivery_phone" :placeholder="$t('getapi[2614]')" type="text"
                                          style="width: 120px" size="mini"></el-input>
                                <span>{{$t('getapi[3597]')}}</span>
                                <el-input v-model="formInline.Head.delivery_leadtime" :placeholder="$t('getapi[3597]')" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                          style="width: 100px" size="mini"></el-input>
                                {{$t('getapi[217]')}}
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[2595]')}}</span>
                                <el-input v-model="formInline.Head.delivery_address" :placeholder="$t('getapi[2595]')"
                                          style="width: 500px" size="mini"></el-input>
                            </div>

                            <div class="bbl">
                                <span>{{$t('getapi[2615]')}}</span>
                                <el-input type="textarea" v-model="formInline.Head.remark" :placeholder="$t('getapi[2615]')"
                                          style="width: 500px"></el-input>
                            </div>
                        </div>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2725]')" name="2">
                        <div>
                            <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="addlines"
                                       :disabled="!btn.rowotheredit">{{$t('getapi[6483]')}}
                            </el-button>
                            <el-button type="primary" size="mini" icon="el-icon-delete-solid" @click="dellines_lists"
                                       v-if="btn.rowotherdel">{{$t('getapi[40]')}}
                            </el-button>
                        </div>
                        <el-table
                                id="xdetilpane-2"
                                :data="formInline.CostLists"
                                header-row-class-name="headerclass"
                                @selection-change="linedelsels"
                                border
                                :height="tableHeight - 270"
                                size="mini"
                                style="width: 100%; margin-top:3px"
                                ref="singleTable2"
                        >
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column prop="cost_item" :label="$t('getapi[2728]')"
                                             width="100">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.cost_item" :placeholder="$t('getapi[2728]')"
                                              size="mini" :disabled="!btn.rowotheredit"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="part_code" :label="$t('getapi[2711]')"
                                             width="100">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.part_code"
                                            :placeholder="$t('getapi[2711]')"
                                            size="mini"
                                            readonly
                                            :disabled="!btn.rowotheredit"
                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectPart(scope)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="net_unitprice" :label="$t('getapi[1303]')"
                                             width="80">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.net_unitprice"
                                            :placeholder="$t('getapi[1303]')"
                                            type="number"
                                            autocomplete="off" title=""
                                            @mousewheel.native.prevent
                                            @input="otherSum(scope, 2)"
                                            size="mini"
                                            :disabled="!btn.rowotheredit"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="total_unitprice" :label="$t('getapi[1302]')"
                                             width="100">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.total_unitprice"
                                            :placeholder="$t('getapi[1302]')"
                                            type="number"
                                            autocomplete="off" title=""
                                            @mousewheel.native.prevent
                                            @input="otherSum(scope, 1)"
                                            size="mini"
                                            :disabled="!btn.rowotheredit"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="quantity" :label="$t('getapi[3101]')"
                                             width="100">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.quantity" :placeholder="$t('getapi[3101]')"
                                              type="number" autocomplete="off" title="" @mousewheel.native.prevent @input="otherSum(scope, 0)" size="mini"
                                              :disabled="!btn.rowotheredit"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="total_amount" :label="$t('getapi[3959]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="net_amount" :label="$t('getapi[1599]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="taxamount" :label="$t('getapi[2729]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column prop="remark" :label="$t('getapi[143]')" width="100">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.remark" :placeholder="$t('getapi[143]')" size="mini"
                                              :disabled="!btn.rowotheredit"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"
                                             align="right" width="100"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2730]')" name="3">
                        <el-table :data="formInline.FHTJList" header-row-class-name="headerclass" border
                                  :height="tableHeight - 235" size="mini"
                                  ref="singleTable3">
                            <el-table-column show-overflow-tooltip prop="sales_part" :label="$t('getapi[2652]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[2654]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[2653]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="sales_unit" :label="$t('getapi[3100]')"
                                             width="80"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="sales_qty" :label="$t('getapi[2182]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="shifa" :label="$t('getapi[2702]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="kaidanweifa" :label="$t('getapi[2717]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="shitui" :label="$t('getapi[2731]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="kaidanweitui" :label="$t('getapi[2719]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="amount" :label="$t('getapi[2732]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="total_qty" :label="$t('getapi[6264]')" align="right"
                                             width="100"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div
                        style="
            text-align: right;line-height: 30px;
            color: #545c64;
            font-size: 95%;
          "
                >
                    {{$t('getapi[7980]')}}:{{ DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <serce :isVisible="isVisible" queryData="SALCOHeaderViewInfo " ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1001]')" queryData="SALCOHeaderViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 客户弹框 -->
        <!--<client :isVisible="false" @getclient="getclient" ref="inputs"></client>-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :selectType="1" :postUrl="'Basic/Popup/GetSALCustomerDataList'"
                  @callback="getclient" ref="inputs"></selector>
        <!--销售件弹框 -->
        <selector :isVisible="false" :isBatch="true" :isSplitPage="true" :postUrl="'Basic/Popup/GetSalPartDataList'"
                  @callback="getsalpart" ref="salinput"></selector>
        <!-- 物料弹框 -->
        <selector :isVisible="false" :isSplitPage="true" :postUrl="'Eng/Parts/GetPartMasterPopupList'"
                  @callback="getPartInfo" ref="inputPart"></selector>
        <!-- 销售人员 -->
       <!-- <employee :isVisible="false" @getemployee="getemployee" ref="inputemp"></employee>-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :selectType="5" :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="inputemp"></selector>
        <!-- 订单 -->
        <itemCodes :isVisivle="false" @getitem="getitem" ref="orinput"></itemCodes>

        <!-- 编辑弹框 -->
        <!-- 单据关闭原因 -->
        <el-dialog v-dialogDrag :visible.sync="visCloseReason" width="30%" :title="$t('getapi[2763]')" :close-on-click-modal="false">
            <div><el-input v-model="reason" type="textarea" rows="5" size="mini"></el-input></div>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="visCloseReason = false">{{$t('getapi[3086]')}}</el-button>
                        <el-button type="primary" @click="mini_qrgb()">{{$t('getapi[1146]')}}</el-button>
                    </span>
        </el-dialog>
        <!-- 行关闭原因 -->
        <el-dialog v-dialogDrag :visible.sync="visLineCloseReason" :title="$t('getapi[2757]')" width="30%" :close-on-click-modal="false">
            <div><el-input v-model="linereason" type="textarea" rows="5"  size="mini"></el-input></div>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="visLineCloseReason = false">{{$t('getapi[3086]')}}</el-button>
                        <el-button type="primary" @click="linetap(4)">{{$t('getapi[1146]')}}</el-button>
                    </span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';

    export default {
        name: 'salorderlist',
        computed: {
            tableOption() {
                let that = this
                if(that.act==1){
                    return {
                        border: true,
                        height: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                        maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                    }
                } else {
                    return {
                        border: true,
                        height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                        maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    }
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                formInline: {
                    list: {
                        BenWei: '0',
                        AmountSUM: '0',
                        Amount_netSUM: '0',
                        Tax_AmountSUM: '0',
                        Cus_AmountSUM: '0'
                    },
                    CoLists: [],
                    CostLists: [],
                    FHTJList: [],
                    Head: {
                        audit_person: '',
                        audit_time: '',
                        benweisummoney: '',
                        consignment_flag: '',
                        contract_info: '',
                        create_person: '',
                        create_time: '',
                        currency_code_id: '',
                        customer_id: '',
                        customer_name: '',
                        customer_order: '',
                        delivery_address: '',
                        delivery_contract: '',
                        delivery_date: '',
                        delivery_leadtime: '',
                        delivery_phone: '',
                        delivery_term: '',
                        direct_move_flag: '',
                        exchange_rate: '',
                        exclusively_id: '',
                        field: '',
                        hanshuisummoney: '',
                        isfillin: '',
                        issue_part_flow: '',
                        moving_pos: '',
                        qushuisummoney: '',
                        remark: '',
                        sale_issue_type: '',
                        salesman: '',
                        shuisummoney: '',
                        status: '',
                        statusname: '生成',
                        tax_code: '',
                        tax_rate: '',
                        transport_type: '',
                        update_person: '',
                        update_time: '',
                        price_type: 0,
                        price_type_name:'',
                        pro_dept:'',
                        after_flag: 0,
                    }
                },
                oldFormInline: '',
                formInlines: {
                    version_status: true,
                    enable_flag: true
                },
                ids: '',
                A57config: 0,//配置信息
                showloading: '',
                isVisible: false,
                editvisi: false,
                visCloseReason:false,//单据关闭原因
                visLineCloseReason:false,//行关闭原因
                reason:'',//单据关闭原因
                linereason:'',//行关闭原因
                linelist: [], //选择行数据
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('salorderlist'),
                SelectIndex: 0,
                oldSelectIndex: 0,
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectData: [],
                selectLData: [],
                selectIDData: '', // 选择的数据的ID集合
                tracetype: 0, //跟踪类别
                isEdit: true, // 是否新增
                itevisible: false, //物料弹框
                ProPositionList: [],
                rouvisible: false,
                roushowindex: 0,
                wcentervisible: false,
                wcentershowindex: 0,
                itemindex: 0,
                editf: true,
                act: '0',
                DeliveryTermList: [], //交货条款
                TransMode: [], //运输方式
                Package: [], //包装方式
                AddressShort: [], //收货地址简称
                exclusively_id: 0,
                currentRow: null,
                lineid: [],
                lineids: [],
                btn: {
                    //从已有订单导入
                    orderimp: false,
                    //从Excel导入
                    execl: false,
                    //获得导入模板
                    imptemplate: false,
                    //审核
                    audit: false,
                    //下达
                    release: false,
                    //取消下达
                    cancelrelease:false,
                    //确认关闭
                    close: false,
                    //行删除
                    rowdel: false,
                    //行下达
                    rowrelease: false,
                    //行强制关闭
                    rowclose: false,
                    //行冻结
                    rowDongJie: false,
                    //行解冻
                    rowJieDong: false,
                    //其它费用项删除
                    rowotherdel: false,
                    //其它费用项文本框是否允许编辑
                    rowotheredit: false,
                    //订单明细文本框是否允许编辑
                    rowedit: false,
                    //新增行
                    rowadd:false,
                },
                authority_showprice: false, // 是否显示价格
                authority_pricecanedit: false,// 价格是否可以编辑
                view_showprice: false, // 一览是否显示价格
                GCurrencyCode: '', // 公司货币
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                btn_batch_release:false,
                RightSelectIndex: '0',
                orderedited:'',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                DeptList: [], //生产部门
                sortRule: {property:null,order:null},
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.getselect();
            //this.getqwlist();
            // that.$http.urlpost('Eng/Routings/GetProPositionList', {}, function (res) {
            //     console.log(res);
            //     if (res.Success == 1) {
            //         that.ProPositionList = res.DataContent;
            //     }
            // });
            that.$http.urlpost('Basic/GetCurARate', {}, function (res) {
                if (res.Success == 1) {
                    that.GCurrencyCode = res.DataContent.currencycode;
                }
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'salelin' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getdlist(data.Relation_Id);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    //that.$processdata.initForm(0)
                    that.$processdata.initAllForm()
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('salorderlist', that)
            that.A57config = that.getA57Config();
            that.orderedited=Array.methods.getSysConfig('A103');
            //that.intidata();
            that.$limits.dragControllerDiv();
            that.confirmAdd();
            that.DeptList = Array.methods.getIssueDeptList();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1001]"),this.$t("getapi[14]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SALCOHeaderViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            // 获取财务类别
            getA57Config() {
                let that = this;
                let result = 0;
                that.userData = sessionStorage.getItem('userData');
                that.token = JSON.parse(that.userData).token;
                $.ajax({
                    url: Common.Url + 'Sal/Order/GetA57Config?token=' + that.token,
                    type: 'post',
                    async: false,
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            result = res.DataContent;
                        } else {
                            //Message.error(res.Msg);
                        }
                    },
                    error: function (xhr, errorType, error) {
                        //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
                return result;
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                // 是否显示价格
                if(that.$limits.authority('plv4', 52, 1) ==  0){
                    that.view_showprice = false
                } else {
                    that.view_showprice = true
                }

                that.btn_batch_release = false;
                if (that.$limits.authority('plv4', 555, 1) > 0) {
                    that.btn_batch_release = true;
                } else {
                    that.btn_batch_release = false ;
                }

                // 编辑是否显示价格
                if(that.$limits.authority('plv4', 63, 1) ==  0){
                    that.authority_showprice = false
                } else {
                    that.authority_showprice = true
                }
                // 价格是否可编辑
                if(that.$limits.authority('plv4', 61, 1) > 0){
                    that.authority_pricecanedit = true
                } else {
                    that.authority_pricecanedit = false
                }
                if(!this.$limits.menuvisible("plv2", 104, 1)){
                    if (that.$limits.ReadOnlyRightsView('plv2', 102, 1, that.total)) {
                        if (that.total > 0) {
                            if (that.$limits.authority('plv3', 104, 1) > 0) {
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权
                    if (that.$limits.authority('plv2', 102, 1) == 2) {
                        //操作权
                        if (that.$limits.authority('plv3', 102, 1) == 0) {
                            //查询级
                            if (that.total > 0) {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                                }
                            } else {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('search,refresh,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                                }
                            }
                        }
                        if (that.$limits.authority('plv3', 102, 1) == 1) {
                            //编辑级
                            if (that.total > 0) {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                                }
                            } else {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                                }
                            }
                        }
                        if (that.$limits.authority('plv3', 102, 1) == 2) {
                            //删除级
                            if (that.total > 0) {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }
                            } else {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                                }
                            }
                        }
                    }
                } else {
                    if (that.$limits.authority('plv2', 104, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                    if (that.$limits.authority('plv2', 104, 1) == 2) {
                        if (that.$limits.authority('plv3', 104,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 104,1) == 1) {
                            //编辑级
                            if (that.$limits.authority('plv3', 104, 1) > 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 104, 1) == 2) {
                            //删除级
                            if (that.formInline.Head.status == 0 && !that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,del,save,search,refresh,export,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,del,save,search,refresh,export');
                                }
                            } else {
                                if (that.$limits.authority('plv3', 104, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }
                            }
                        }
                    }
                }

                if(that.formInline.Head.status ==4){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }
                that.btnauthority();
            },
            btnauthority() {
                //单据右键按钮功能
                let that = this;
                //从已有订单导入
                that.btn.orderimp = false;
                //从Excel导入
                that.btn.execl = false;
                //获得导入模板
                that.btn.imptemplate = false;
                that.btn.rowotheredit = false;
                that.btn.rowedit = false;
                that.btn.rowadd = true;

                that.isEdit = false;
                if (that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                    if(that.orderedited!='1'){
                        that.isEdit = true;
                    }
                }
                if (that.formInline.Head.status==4 ) {
                    that.btn.rowadd=false;
                }
                else{
                    that.btn.rowadd=true;
                }

                //单据下达或者关闭 其它页签不允许修改
                if (that.formInline.Head.status > 0) {
                    that.btn.rowotheredit = false;
                    that.btn.rowedit = false;
                }
                else {
                    that.btn.rowotheredit = true;
                    that.btn.rowedit = true;
                }

                if (that.$limits.authority('plv3', 104, 1) == 0) {
                    that.btn.orderimp = false;
                } else {
                    if (that.formInline.Head.status != 0) {
                        that.btn.orderimp = false;
                    }
                    else {
                        that.btn.orderimp = true;
                    }
                }

                //新增单据时
                if (that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                    that.btn.audit = false;
                    that.btn.release = false;
                    that.btn.cancelrelease=false;
                    that.btn.close = false;
                }
                //单据右键功能按钮
                if (!that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                    //是否启用核准下达功能，没启用直接下达，启用后，先审核后下达
                    that.$http.urlpost('/Sal/Order/GetA84Config', '', function (res) {
                        if (res.Success == 1) {
                            if(res.DataContent != 1){
                                if(that.formInline.Head.status == 0){
                                    that.btn.audit = false;
                                    that.btn.release = true;
                                    if (that.$limits.authority('plv3', 104, 1) == 0) {
                                        that.btn.release = false;
                                    } else {
                                        if (that.$limits.authority('plv4', 50, 1) == 0) {
                                            that.btn.release = false;
                                        } else {
                                            if (that.formInline.Head.status != 0) {
                                                that.btn.release = false;
                                            }
                                        }
                                    }
                                }
                            } else {
                                if(that.$limits.authority('plv4', 156, 1) > 0){
                                    if(that.formInline.Head.status == 0){
                                        that.btn.audit = true
                                        that.btn.release = false;
                                        if(that.formInline.Head.Director_Flag == 1){
                                            that.btn.release = true;
                                            if (that.$limits.authority('plv3', 104, 1) == 0) {
                                                that.btn.release = false;
                                            } else {
                                                if (that.$limits.authority('plv4', 50, 1) == 0) {
                                                    that.btn.release = false;
                                                } else {
                                                    if (that.formInline.Head.status != 0) {
                                                        that.btn.release = false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    that.btn.audit = false;
                                    that.btn.release = false;
                                }
                            }
                        }
                    });
                    //确认关闭
                    that.btn.close = true;
                    //确认关闭
                    if (that.$limits.authority('plv3', 104, 1) == 0) {
                        that.btn.close = false;
                    } else {
                        if (that.$limits.authority('plv4', 51, 1) == 0) {
                            that.btn.close = false;
                        } else {
                            if (that.formInline.Head.status == 0 || that.formInline.Head.status == 4) {
                                that.btn.close = false;
                            }
                        }
                    }
                    //取消下达
                    if (that.$limits.authority('plv4', 578, 1) > 0) {
                        if (that.formInline.Head.status == 1) {
                            that.btn.cancelrelease = false;
                        }
                        else{
                            that.btn.cancelrelease = true;
                        }
                    }
                    else{
                        that.btn.cancelrelease = true;
                    }
                }
                //明细行右键功能按钮 默认值
                //行删除
                that.btn.rowdel = false;
                //行下达
                that.btn.rowrelease = false;
                //行强制关闭
                that.btn.rowclose = false;
                //行冻结
                that.btn.rowDongJie = false;
                //行解冻
                that.btn.rowJieDong = false;
                var rowNum = that.selectData.length - 1;
                var otherrowNum = that.lineids.length - 1;
                if (that.lineids.length > 0) {
                    //其它费用项删除
                    that.btn.rowotherdel = true;
                    if (that.$limits.authority('plv3', 104, 1) == 0) {
                        that.btn.rowotherdel = false;
                    } else {
                        //操作级
                        if (that.$limits.authority('plv4', 49, 1) == 0) {
                            //查询级
                            that.btn.rowotherdel = false;
                        } else {
                            ////选中一行为新增行，不能删除
                            if (that.lineids.length == 1 && that.$limits.fnIsEmpty(that.lineids[otherrowNum].exclusively_id)) {
                                that.btn.rowotherdel = true;
                            }
                            //状态不是生成，也不能删除；
                            if (that.formInline.Head.status != 0) {
                                that.btn.rowotherdel = false;
                            }
                        }
                    }
                }

                if (that.selectData.length > 0) {
                    that.btn.rowdel = true;
                    if (that.$limits.authority('plv3', 104, 1) == 0) {
                        that.btn.rowdel = false;
                    } else {
                        //操作级
                        if (that.$limits.authority('plv4', 49, 1) == 0) {
                            //查询级
                            that.btn.rowdel = false;
                        } else {
                            ////选中一行为新增行，不能删除
                            if (that.selectData.length == 1 && that.$limits.fnIsEmpty(that.selectData[rowNum].exclusively_id)) {
                                that.btn.rowdel = true;
                            }

                            //状态不是生成，也不能删除；
                            if (that.formInline.Head.status != 0) {
                                that.btn.rowdel = false;
                            }
                        }
                    }

                    //强制行关闭
                    that.btn.rowclose = true;
                    if (that.$limits.authority('plv4', 78, 1) == 0) {
                        //查询级
                        that.btn.rowclose = false;
                    } else {
                        if (that.selectData[rowNum].status == 4) {
                            that.btn.rowclose = false;
                        } else {
                            that.btn.rowclose = true;
                        }
                    }
                    if (!that.$limits.fnIsEmpty(that.selectData[rowNum].exclusively_id)) {
                        //行冻结
                        that.btn.rowDongJie = true;
                        //行解冻
                        that.btn.rowJieDong = true;
                        switch (that.selectData[rowNum].freeze_flag) {
                            case -1:
                                that.btn.rowDongJie = false;
                                //行解冻
                                that.btn.rowJieDong = false;
                                break;
                            case 0: //解冻

                                that.btn.rowJieDong = false;
                                if (that.$limits.authority('plv4', 371, 1) == 0) {
                                    that.btn.rowDongJie = false;
                                } else {
                                    if (that.$limits.fnIsEmpty(that.selectData[rowNum].exclusively_id) && that.selectData.length == 1) {
                                        that.btn.rowDongJie = false;
                                    }
                                    if (that.selectData[rowNum].status == 0 || that.selectData[rowNum].status == 4) {
                                        that.btn.rowDongJie = false;
                                    }
                                }
                                break;
                            case 1: //冻结
                                that.btn.rowDongJie = false;
                                if (that.$limits.authority('plv4', 371, 1) == 0) {
                                    that.btn.rowJieDong = false;
                                } else {
                                    if (that.$limits.fnIsEmpty(that.selectData[rowNum].exclusively_id) && that.selectData.length == 1) {
                                        that.btn.rowJieDong = false;
                                    }
                                    if (that.selectData[rowNum].status == 0 || that.selectData[rowNum].status == 4) {
                                        that.btn.rowJieDong = false;
                                    }
                                }
                                break;
                        }
                    }
                }
            },
            getdatatime(row,type) {
                let that=this;
                let index = row.$rowIndex;
                if(type==1) {
                    if (that.$limits.fnIsEmpty(that.formInline.CoLists[index].plan_delivery_date)) {
                        return;
                    } else {
                        that.formInline.CoLists[index].plan_delivery_date =that.$limits.parseTime(that.formInline.CoLists[index].plan_delivery_date, "{y}-{m}-{d}");
                    }
                }
                else if(type==2) {
                    if (that.$limits.fnIsEmpty(that.formInline.CoLists[index].commit_delivery_date)) {
                        return;
                    } else {
                        that.formInline.CoLists[index].commit_delivery_date =that.$limits.parseTime(that.formInline.CoLists[index].commit_delivery_date, "{y}-{m}-{d}");
                    }
                }

            },
            tableRowClassNameNot({row, rowIndex}) {
                row.index = rowIndex;
                if(row.statusname == '生成'){
                    if(row.batch_flag == 1){
                        return 'green'
                    }
                   /* let qty = 0
                    for(let i = 0;i<this.formInline.CoLists.length;i++){
                        if(row.sales_part == this.formInline.CoLists[i].sales_part){
                            qty = qty + parseFloat(this.formInline.CoLists[i].sales_qty)
                        }
                    }
                    let parm = {
                        sales_part_ID: row.sales_part_id,
                        currencyCode: this.formInline.Head.currency_code_id,
                        qty: qty,
                        customerCode: this.formInline.Head.customer_id
                    }
                    let flag = false
                    this.token = JSON.parse(this.userData).token;
                    $.ajax({
                        url: Common.Url + '/Sal/Order/CheckIsHaveMostSmall?token=' + this.token,
                        type: 'post',
                        async: false,
                        contentType: 'application/json',
                        data: JSON.stringify(parm),
                        success: function (res) {
                            if (res.Success == 1) {
                                if(res.DataContent.Table1[0].result == 1){
                                    flag = true
                                }
                            } else {
                                //Message.error(res.Msg);
                            }
                        },
                        error: function (xhr, errorType, error) {
                            //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                        }
                    });
                    if(flag){
                        return 'green'
                    }*/
                }
            },
            //tabs
            handleClick(tab, event) {
                let that = this
                this.SelectIndex = tab.name;
                this.act=tab.name
                if(tab.name == 1){
                    that.tableOption = {
                        border: true,
                        height: Common.tableHeight3 - Common.reduceTableHeight1, // 主表高度ss
                        maxHeight: Common.tableHeight3 // 主表高度
                    }
                } else {
                    that.tableOption = {
                        border: true,
                        height: Common.tableHeight3 - Common.reduceTableHeight2, // 主表高度ss
                        maxHeight: Common.tableHeight3 // 主表高度
                    }
                }
                console.log(tab.name);
                this.intidata();
                this.colsort()
            },
            selectInfo(tab){
                this.RightSelectIndex=tab.name
                this.$nextTick(function(){
                    this.$processdata.initAllForm()
                    //this.$processdata.initFormRight(this.RightSelectIndex)
                });
            },
             // 批量下达
             SalBatchCoRelease() {
                let that = this;
                let parm = [];
                let langt = that.$processdata.getLang()
                for (let i = 0; i < that.selectLData.length; i++) {
                    parm = [
                        ...parm,
                        {
                            exclusively_id: that.selectLData[i].Exclusively_Id,
                            customer_order: that.selectLData[i].Customer_Order,
                            status: that.selectLData[i].Status,
                            LangType: langt
                        }
                    ];
                }
                that.$http.urlpost('/Sal/Order/SalBatchCoRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata();
                    }
                });
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                if (row.enable_flag == '是') {
                    return 'warning-row';
                }
                if (row.version_status == '不可用') {
                    return 'dark-row';
                }
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
            },
            //物料弹框s
            doTheThing() {
                console.log('客户弹框开启');
                this.$refs.inputs.clearInput(true, 1);
            },
            // 销售员
            peop() {
                this.$refs.inputemp.clearInput(true, false, 5);
            },
            // 获取
            getemployee(e) {
                this.formInline.Head.salesman = e.name;
            },
            //获取客户信息
            getclient(val) {
                let that = this
                console.log(val);
                this.formInline.Head.consignment_flag = val.consignment_type == '常规销售' ? 0 : 1;
                this.formInline.Head.currency_code_id = val.currency_code_id;
                this.formInline.Head.customer_id = val.customer_id;
                this.formInline.Head.customer_name = val.customer_name;
                this.formInline.Head.delivery_address = val.delivery_address;
                this.formInline.Head.delivery_contract = val.delivery_contract;
                this.formInline.Head.delivery_leadtime = val.delivery_leadtime;
                this.formInline.Head.delivery_phone = val.delivery_phone;
                this.formInline.Head.delivery_term = val.delivery_term;
                this.formInline.Head.direct_move_flag = val.direct_move_flag == '是' ? 1 : 0;
                this.formInline.Head.issue_part_flow = val.issue_part_flow == '是' ? 1 : 0;
                this.formInline.Head.remark = val.remark;
                this.formInline.Head.salesman = val.sal_empname;
                this.formInline.Head.sale_issue_type = val.sale_issue_type;
                this.formInline.Head.tax_code = val.tax_code;
                this.formInline.Head.tax_rate = val.tax_rate;
                this.formInline.Head.transport_type = val.transport_type;
                this.formInline.Head.moving_pos = val.moving_pos;
                this.formInline.Head.Address_ShortName_Id = val.Address_ShortName_ID
                this.formInline.Head.price_type = val.price_type
                // 交货条款
                that.getInfoCustomerID(val.customer_id)
            },
            // 根据客户编码获取交货地址简称数组
            getInfoCustomerID(val){
                let that = this
                let parm = {
                    Customer_ID:  val
                }
                that.$http.urlpost('/Sal/Order/GetSALCustomerInfoCOByCustomerID', parm, function (res) {
                    if (res.Success == 1) {
                        that.AddressShort = res.DataContent;
                    }
                })
            },
            //新增其它费用项
            addlines() {
                let that = this;
                let deti = {
                    add: true,
                    exclusively_id: 0,
                    line_no: that.formInline.CostLists.length + 1,
                    co_id: '',
                    cost_item: '',
                    net_unitprice: 0,
                    total_unitprice: 0,
                    total_amount: 0,
                    statusname: '生成',
                    net_amount: 0,
                    taxamount: 0,
                    quantity: 0,
                    modify_person: '',
                    modify_time: '',
                    part_code: '',
                    remark: '',
                    yz: 0,
                    isadd: 1
                };
                that.formInline.CostLists.push(deti);
                that.$nextTick(function () {
                    that.$processdata.initAllForm()
                })
            },
            //其它费用项选择销售件
            selectPart(data) {
                let that = this;
                if (that.$limits.fnIsEmpty(that.formInline.Head.customer_id)) {
                    that.$message.warning(that.$t('getapi[2756]'));//'请先选择订单客户'
                    return;
                }
                if (data.row.cost_item) {
                    that.itemindex = data.$index;
                    that.$refs.inputPart.clearInput(true, '');
                } else {
                    that.$message.error(that.$t('getapi[2780]'));
                }
            },
            //获取物料信息
            getPartInfo(data) {
                let that = this;
                that.formInline.CostLists[that.itemindex].part_code = data.part_code;
            },
            //工序弹框
            showrout(row) {
                console.log(row);
                this.rouvisible = true;
                this.roushowindex = row.$index;
                this.$refs.routs.clearInput(this.rouvisible);
            },
            //销售件弹框
            showwcenter(row) {
                let that = this;
                if (that.$limits.fnIsEmpty(that.formInline.Head.customer_id)) {
                    that.$message.warning(that.$t('getapi[2756]'));//'请先选择订单客户'
                    return;
                }
                if (row != '') {
                    this.wcentershowindex = row.$index;
                } else {
                    this.rowindex = -1
                }
                that.wcentervisible = true;
                let rat = this.formInline.Head.tax_rate;
                rat = rat / 100;
                let param = {
                    currency_code: that.formInline.Head.currency_code_id,
                    customer_code: that.formInline.Head.customer_id,
                    tax_rate: rat,
                    after_flag: that.formInline.Head.after_flag,
                    baseprice_flag: that.formInline.Head.baseprice_flag,
                }
                this.$refs.salinput.clearInput(that.wcentervisible, param);
            },

            //获取销售件信息 新增销售件明细
            getsalpart(data) {
                console.log(data);
                let that = this;
                var status = 0;
                var statusname = '生成';
                if (that.formInline.Head.status == 1 || that.formInline.Head.status == 2 || that.formInline.Head.status == 3) {
                    status = 1;
                    statusname = '下达';
                }
                let dataDetailLineNo = 1
                for (let i = 0; i < that.formInline.CoLists.length; i++) {
                    if (that.formInline.CoLists[i].line_no >= dataDetailLineNo) {
                        dataDetailLineNo = that.formInline.CoLists[i].line_no + 1
                    }
                }
                for (let i = 0; i < data.length; i++) {
                    that.formInline.CoLists = [
                        ...that.formInline.CoLists,
                        {
                            exclusively_id: 0,
                            line_no: dataDetailLineNo++,
                            freeze_flag: 0,
                            status: status,
                            statusname: statusname,
                            exchange_rate: data[i].change_rate,
                            cuspart_id: data[i].cuspart_id,
                            cuspart_name: data[i].cuspart_name,
                            cust_version: that.A57config == 1 ? '' : data[i].cust_version,
                            model: data[i].model,
                            price_net: data[i].net_unit_price,
                            package: data[i].package_type,
                            part_name: data[i].part_name,
                            part_version: data[i].part_version,
                            price_withtax: data[i].unit_price,
                            sale_part_code: data[i].sale_part_code,
                            sales_unit: data[i].sale_unit,
                            source: data[i].source,
                            spec: data[i].spec,
                            trace: data[i].trace,
                            sales_part: data[i].sale_part_code,
                            sales_part_id: data[i].exclusively_id,
                            xcust_version: data[i].cust_version,
                            customer_item: dataDetailLineNo - 1,
                            isadd: 1,
                            add: true,
                            page_no: data[i].page_no,
                            cus_chartnum: data[i].cus_chartnum,
                            isestimateprice: data[i].isestimateprice,
                        }
                    ];
                }
                that.$nextTick(function () {
                    that.$processdata.initAllForm()
                })
            },
            getMaxLine() {
                let that = this;
                var MaxLine = 0;
                var DTLine = that.formInline.CoLists.length;
                for (var i = 0; i < that.formInline.CoLists.length; i++) {
                    if (MaxLine < that.formInline.CoLists[i].line_no) {
                        MaxLine = that.formInline.CoLists[i].line_no;
                    }
                }
                return MaxLine + 1;
            },
            // 订单明细计算金额
            detailSum(row, type) {
                let that = this;
                if (that.timeId) {
                    clearTimeout(that.timeId)
                }
                console.log(row.$rowIndex)
                that.timeId = setTimeout(() => {
                    let token = JSON.parse(that.userData).token;
                    //当税率为空时直接返回；不计算
                    /*if (that.$limits.fnIsEmpty(that.formInline.Head.tax_rate)) {
                        return;
                    }*/
                    let index = row.$rowIndex;
                    let colist = this.formInline.CoLists[index];
                    //税率
                    let rat = this.formInline.Head.tax_rate;
                    rat = rat / 100;
                    //销售数量
                    let sales_qty = typeof colist.sales_qty == 'undefined' ? 0 : colist.sales_qty;
                    //不含税单价
                    let price_net = typeof colist.price_net == 'undefined' ? 0 : colist.price_net;
                    //含税单价
                    let price_withtax = typeof colist.price_withtax == 'undefined' ? 0 : colist.price_withtax;
                    let ratePrice = 0; //税价
                    if (type == 0) {//数量
                        console.log(row)
                        if(this.formInline.Head.price_type == 0){
                            if(row.row.statusname == '生成'){
                                let sales_part = row.row.sales_part
                                let qty = 0
                                for(let j =0;j< that.formInline.CoLists.length;j++){
                                    if (that.formInline.CoLists[j].sales_part == sales_part && that.formInline.CoLists[j].statusname == '生成') {
                                        qty = qty + parseFloat(that.formInline.CoLists[j].sales_qty)
                                        console.log(j+'循环' + sales_part)
                                    }
                                }
                                let parm = {
                                    sale_Part_Code: row.row.sales_part,
                                    sale_Part_Version: row.row.part_version,
                                    customer_Code: that.formInline.Head.customer_id,
                                    sales_part_ID: row.row.sales_part_id,
                                    currencyCode: that.formInline.Head.currency_code_id,
                                    qty: qty,
                                    customerCode: that.formInline.Head.customer_id,
                                    after_flag: that.formInline.Head.after_flag,
                                }
                                $.ajax({
                                    url: Common.Url + '/Sal/Order/GetExistSalPartNetPrice?token=' + token,
                                    type: 'post',
                                    async: false,
                                    data: JSON.stringify(parm),
                                    contentType: 'application/json',
                                    success: function (res1) {
                                        if (res1.Success == 1 && res1.DataContent.dt1[0].result == 2) {
                                            for (let i = 0; i < that.formInline.CoLists.length; i++) {
                                                if (that.formInline.CoLists[i].sales_part == sales_part && that.formInline.CoLists[i].statusname == '生成') {
                                                    // that.formInline.CoLists[i].price_withtax = res1.DataContent.Line[0].price
                                                    if(that.formInline.Head.baseprice_flag  == 0){
                                                        that.formInline.CoLists[i].price_net = res1.DataContent.Line[0].net_price
                                                        //通过不含税价格计算含税价格，不以价表数据为准
                                                        price_withtax = res1.DataContent.Line[0].net_price * (1 + rat);
                                                        that.formInline.CoLists[i].price_withtax = price_withtax.toFixed(4);
                                                    } else {
                                                        that.formInline.CoLists[i].price_withtax =  res1.DataContent.Line[0].price
                                                        price_net = res1.DataContent.Line[0].price / (1 + rat);
                                                        that.formInline.CoLists[i].price_net = price_net.toFixed(4);
                                                    }
                                                }
                                            }
                                        }
                                        that.getAllAmount()
                                        clearTimeout(that.timeId)
                                    }
                                });
                            } else {
                                let data = {
                                    sale_Part_Code: row.row.sales_part,
                                    sale_Part_Version: row.row.part_version,
                                    customer_Code: that.formInline.Head.customer_id,
                                    sales_part_ID: row.row.sales_part_id,
                                    currencyCode: that.formInline.Head.currency_code_id,
                                    qty: parseFloat(row.row.sales_qty),
                                    customerCode: that.formInline.Head.customer_id,
                                    after_flag: that.formInline.Head.after_flag,
                                }
                                that.$http.urlpost('/Sal/Order/GetExistSalPartNetPrice', data, function (res) {
                                    if (res.Success == 1 && res.DataContent.dt1[0].result == 2) {
                                        if(that.formInline.Head.baseprice_flag  == 0){
                                            row.row.price_net = res.DataContent.Line[0].net_price
                                            //通过不含税价格计算含税价格，不以价表数据为准
                                            price_withtax = res.DataContent.Line[0].net_price * (1 + rat);
                                            row.row.price_withtax = price_withtax.toFixed(4);
                                        } else {
                                            row.row.price_withtax =  res.DataContent.Line[0].price
                                            price_net = res.DataContent.Line[0].price / (1 + rat);
                                            row.row.price_net = price_net.toFixed(4);
                                        }

                                    }
                                    that.getAllAmount()
                                    clearTimeout(that.timeId)
                                });
                            }
                        } else {
                            let data = {
                                sale_Part_Code: row.row.sales_part,
                                sale_Part_Version: row.row.part_version,
                                customer_Code: that.formInline.Head.customer_id,
                                sales_part_ID: row.row.sales_part_id,
                                currencyCode: that.formInline.Head.currency_code_id,
                                qty: parseFloat(row.row.sales_qty),
                                customerCode: that.formInline.Head.customer_id,
                                after_flag: that.formInline.Head.after_flag,
                            }
                            that.$http.urlpost('/Sal/Order/GetExistSalPartNetPrice', data, function (res) {
                                if (res.Success == 1 && res.DataContent.dt1[0].result == 2) {
                                    // row.row.price_withtax = res.DataContent.Line[0].price
                                    if(that.formInline.Head.baseprice_flag  == 0){
                                        row.row.price_net = res.DataContent.Line[0].net_price
                                        //通过不含税价格计算含税价格，不以价表数据为准
                                        price_withtax = res.DataContent.Line[0].net_price * (1 + rat);
                                        row.row.price_withtax = price_withtax.toFixed(4);
                                    } else {
                                        row.row.price_withtax =  res.DataContent.Line[0].price
                                        price_net = res.DataContent.Line[0].price / (1 + rat);
                                        row.row.price_net = price_net.toFixed(4);
                                    }

                                }
                                that.getAllAmount()
                                clearTimeout(that.timeId)
                            });
                        }
                    }
                    if (type == 1) {//含税
                        console.log("含税")
                        price_net = price_withtax / (1 + rat);
                        that.formInline.CoLists[index].price_net = price_net.toFixed(4);
                        that.getAllAmount()
                        clearTimeout(that.timeId)
                    }
                    if (type == 2) {//不含税
                        console.log("不含税")
                        price_withtax = price_net * (1 + rat);
                        that.formInline.CoLists[index].price_withtax = price_withtax.toFixed(4);
                        that.getAllAmount()
                        clearTimeout(that.timeId)
                    }
                    /*ratePrice = that.formInline.CoLists[index].price_net * rat;
                    that.formInline.CoLists[index].tax_amount = (ratePrice * that.formInline.CoLists[index].sales_qty).toFixed(4);
                    that.formInline.CoLists[index].amount = (that.formInline.CoLists[index].price_withtax * that.formInline.CoLists[index].sales_qty).toFixed(4);*/
                    if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                        that.formInline.CoLists[index].yz = 1;
                    }
                }, 500);

                /*//去税税金额
                let OtherNoTaxTotal = 0;
                //总税额
                let OtherTax = 0;
                //含税金额
                let OtherTotal = 0;
                if (that.formInline.CostLists.length > 0) {
                    for (var i = 0; i < that.formInline.CostLists; i++) {
                        let OtherNoTaxTotal_line = 0;
                        let OtherTax_line = 0;
                        let OtherTotal_line = 0;

                        OtherTax_line = that.formInline.CostLists[i].taxamount;
                        OtherTotal_line = that.formInline.CostLists[i].total_amount;
                        OtherNoTaxTotal_line = that.formInline.CostLists[i].net_amount;

                        OtherNoTaxTotal = OtherNoTaxTotal + OtherNoTaxTotal_line;
                        OtherTax = OtherTax + OtherTax_line;
                        OtherTotal = OtherTotal + OtherTotal_line;
                    }
                }
                //总和计算
                let m1s = 0; //总税额
                let m2s = 0; //总金额
                let m3s = 0; //总去税额
                that.formInline.CoLists.forEach(item => {
                    m2s += parseFloat(item.amount);
                    m1s += parseFloat(item.tax_amount);
                });
                m3s = m2s - m1s;

                that.formInline.list.AmountSUM = (m2s + OtherTotal).toFixed(4);
                that.formInline.list.Amount_netSUM = (m3s + OtherNoTaxTotal).toFixed(4);
                that.formInline.list.Tax_AmountSUM = (m1s + OtherTax).toFixed(4);*/

            },
            getAllAmount(){
                let that = this
                console.log('计算')
                let BenWei = 0
                let AmountSUM = 0
                let Amount_netSUM = 0
                let Tax_AmountSUM = 0
                let Cus_AmountSUM=0
                for(let i = 0;i<that.formInline.CoLists.length;i++){
                    let sales_qty = 0
                    let price_withtax = 0
                    let price_net = 0
                    let shuidanjia = 0
                    if(that.formInline.CoLists[i].sales_qty != null && that.formInline.CoLists[i].price_withtax != null && that.formInline.CoLists[i].price_net != null){
                        sales_qty = that.$processdata.mathRound4(that.formInline.CoLists[i].sales_qty)
                        price_withtax = that.$processdata.mathRound4(that.formInline.CoLists[i].price_withtax)
                        price_net = that.$processdata.mathRound4(that.formInline.CoLists[i].price_net)
                        shuidanjia = price_net * parseFloat(that.formInline.Head.tax_rate) / 100
                        that.formInline.CoLists[i].tax_amount = ((that.formInline.CoLists[i].price_withtax - that.formInline.CoLists[i].price_net) * sales_qty).toFixed(4);
                        that.formInline.CoLists[i].amount = (price_withtax * sales_qty).toFixed(4);
                    }
                    Tax_AmountSUM += shuidanjia * sales_qty
                    AmountSUM += price_withtax * sales_qty
                    Amount_netSUM += price_net * sales_qty
                    let huilv = 0
                    if(that.GCurrencyCode == that.formInline.Head.currency_code_id){
                        huilv = 1
                    } else {
                        if(huilv == 0)huilv = 1
                    }
                    BenWei = AmountSUM * huilv
                    Cus_AmountSUM=Cus_AmountSUM+that.formInline.CoLists[i].customer_Amount;
                }
                console.log('含税' + AmountSUM)
                let OtherNoTaxTotal = 0;
                let OtherTax = 0;
                let OtherTotal = 0;
                for(let i=0;i<that.formInline.CostLists.length;i++){
                    let OtherNoTaxTotal_line = 0;
                    let OtherTax_line = 0;
                    let OtherTotal_line = 0;
                    OtherTax_line = that.formInline.CostLists[i].taxamount;
                    OtherTotal_line = that.formInline.CostLists[i].total_amount;
                    OtherNoTaxTotal_line = that.formInline.CostLists[i].net_amount;

                    OtherNoTaxTotal = OtherNoTaxTotal + OtherNoTaxTotal_line;
                    OtherTax = OtherTax + OtherTax_line;
                    OtherTotal = OtherTotal + OtherTotal_line;
                }
                let huilvother = 0
                if(that.GCurrencyCode == that.formInline.Head.currency_code_id){
                    huilvother = 1
                } else {
                    if(huilvother == 0)huilvother = 1
                }
                BenWei = BenWei + OtherTotal * huilvother
                that.formInline.list.BenWei =  that.$processdata.mathRound4(BenWei)
                that.formInline.list.Amount_netSUM = that.$processdata.mathRound4(Amount_netSUM + OtherNoTaxTotal)
                that.formInline.list.Tax_AmountSUM = that.$processdata.mathRound4(Tax_AmountSUM + OtherTax)
                that.formInline.list.AmountSUM = that.$processdata.mathRound4(AmountSUM + OtherTotal)
                that.formInline.list.Cus_AmountSUM = that.$processdata.mathRound4(Cus_AmountSUM)
            },
            // 其他费用计算金额
            otherSum(row, type) {
                let that = this;
                console.log("税率" + that.formInline.Head.tax_rate);
                //当税率为空时直接返回；不计算
                if (that.formInline.Head.tax_rate === '' || that.formInline.Head.tax_rate == null || undefined == that.formInline.Head.tax_rate) {
                    return;
                }
                let index = row.$index;
                let colist = that.formInline.CostLists[index];
                //税率
                let rat = that.formInline.Head.tax_rate;
                //销售数量
                let quantity = typeof colist.quantity == 'undefined' ? 0 : colist.quantity;
                //不含税单价
                let net_unitprice = typeof colist.net_unitprice == 'undefined' ? 0 : colist.net_unitprice;
                //含税单价
                let total_unitprice = typeof colist.total_unitprice == 'undefined' ? 0 : colist.total_unitprice;
                let ratePrice = 0; //税价
                if (type == 0) {//数量
                    if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                        colist.yz = 1;
                    }
                }
                if (type == 1) {//含税单价 字段
                    net_unitprice = total_unitprice / (1 + rat / 100);
                    that.formInline.CostLists[index].net_unitprice = net_unitprice.toFixed(4);
                }
                if (type == 2) {//不含税单价字段
                    total_unitprice = net_unitprice * (1 + rat / 100);
                    that.formInline.CostLists[index].total_unitprice = total_unitprice.toFixed(4);
                }
                ratePrice = net_unitprice * rat / 100;
                that.formInline.CostLists[index].taxamount = (ratePrice * that.formInline.CostLists[index].quantity).toFixed(4);
                that.formInline.CostLists[index].total_amount = (that.formInline.CostLists[index].total_unitprice * that.formInline.CostLists[index].quantity).toFixed(4);
                that.formInline.CostLists[index].net_amount = (that.formInline.CostLists[index].net_unitprice * that.formInline.CostLists[index].quantity).toFixed(4);
            },
            //删除行
            delline(e) {
                let line = e.$index;
                this.formInline.CoLists.splice(line, 1);
                let lins = line - 1 <= 0 ? 0 : line - 1;
                let pamr = {
                    $index: lins
                };
                this.detailSum(pamr, 0);
            },
            //删除行
            dellines(e) {
                let line = e.$index;
                this.formInline.CostLists.splice(line, 1);
                if (this.formInline.CostLists.length <= 0) {
                    this.addlines(0);
                }
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('salorderlist',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                that.$http.urlpost('Sal/Order/GetSalOrderList', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            //获取工艺清单
            getdlist(id) {
                let that = this;
                let parm = {
                    Code: id
                };
                that.exclusively_id = id;
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Sal/Order/GetSalCoBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.formInline.Head = res.DataContent.Head;
                        that.lineid = [];
                        that.selectData = [];
                        let c = res.DataContent.CoLists;
                        let c1 = res.DataContent.CostLists;

                        if (c.length > 0) {
                            c.forEach(function (item, index) {
                                item.add = true;
                                item.linid = index;
                            });
                            that.formInline.CoLists = c;
                        } else {
                            that.formInline.CoLists = c;
                        }
                        if (c1.length > 0) {
                            c1.forEach(item => {
                                item.add = true;
                            });
                            that.formInline.CostLists = c1;
                        } else {
                            that.formInline.CostLists = c1;
                        }
                        that.formInline.FHTJList = res.DataContent.FHTJList;
                        that.getAllAmount()
                        that.oldFormInline = JSON.stringify(that.formInline)
                        that.getInfoCustomerID(that.formInline.Head.customer_id)
                        that.authority();
                        that.$nextTick(function () {
                            that.$processdata.initAllForm()
                            //that.$processdata.initFormRight(this.RightSelectIndex)
                        })
                    }
                    loadingInstance.close()
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.loading = true;
                let parm = {
                    Head: that.formInline.Head,
                    CoLists: that.formInline.CoLists,
                    CostLists: that.formInline.CostLists,
                    LangType:that.$processdata.getLang(),
                };
                that.$http.urlpost('Sal/Order/SalCoSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        that.getdlist(res.UniqueNum);
                        that.editvisi = false;
                    }
                    that.loading = false;
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Eng/Routings/QWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },
            // 编辑
            edit(jsd) {
                let that = this;
                that.editvisi = true;
                that.editf = false;
                that.getdlist(jsd.row.Exclusively_Id);
                that.formInline.list = jsd.row;
                that.authority();
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                that.selectLData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectLData.push(val[i]);
                }
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
                that.btnauthority();
            },
            imp() {
                let item = {
                    //label: '销售订单导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/16',
                    url: '/exp/16',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/16'});
                this.$store.commit('selectMenu', item);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    exclusively_id: that.ids,
                    status: 0
                };
                that.$http.urlpost('Sal/Order/DelSalOrder', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该销售订单, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.formInline.Head.exclusively_id,
                            status: that.formInline.Head.status
                        };
                        that.$http.urlpost('/Sal/Order/DelSalOrder', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata();
                                that.confirmAdd();
                            }
                        });

                    })
                    .catch(() => {
                    });
            },
            movef(e) {
                this.formInline.direct_stuff_move_flag = e;
            },
            //冻结解冻
            enable(e) {
                let that = this;
                let parm = {
                    Id: 0,
                    Code: that.formInline.exclusively_id,
                    Name: '',
                    Where: ''
                };
                if (e) {
                    that.$http.urlpost('Eng/Routings/ThawRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.enable_flag = true;
                            that.formInlines.enable_flag = true;
                            that.$message.success(that.$t('getapi[1194]'));
                        }
                    });
                } else {
                    that.$http.urlpost('Eng/Routings/FrozenRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.enable_flag = false;
                            that.formInlines.enable_flag = false;
                            that.$message.success(that.$t('getapi[1194]'));
                        }
                    });
                }
            },
            // 可用/不可用
            status(e) {
                let that = this;
                let parm = {
                    partid: that.formInline.part_code,
                    routingid: that.formInline.exclusively_id,
                    routingversion: that.formInline.routing_version,
                    LangType: that.$processdata.getLang(),
                };
                if (e) {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = 1;
                            that.formInlines.version_status = true;
                            that.$message.success(that.$t('getapi[1194]'));
                        }
                    });
                } else {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = 0;
                            that.formInlines.version_status = false;
                            that.$message.success(that.$t('getapi[1194]'));
                        }
                    });
                }
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.formInline
                for (let i = 0; i < datacopy.CoLists.length; i++) {
                    delete datacopy.CoLists[i]['index']
                    delete datacopy.CoLists[i]['_XID']
                }
                if (that.oldFormInline != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                this.formInline = {
                    list: {
                        BenWei: '0',
                        AmountSUM: '0',
                        Amount_netSUM: '0',
                        Tax_AmountSUM: '0'
                    },
                    CoLists: [],
                    CostLists: [],
                    FHTJList: [],
                    Head: {
                        audit_person: '',
                        audit_time: '',
                        benweisummoney: '',
                        consignment_flag: '',
                        contract_info: '',
                        create_person: '',
                        create_time: '',
                        currency_code_id: '',
                        customer_id: '',
                        customer_name: '',
                        customer_order: '',
                        delivery_address: '',
                        delivery_contract: '',
                        delivery_date: '',
                        delivery_leadtime: '',
                        delivery_phone: '',
                        delivery_term: '',
                        direct_move_flag: '',
                        exchange_rate: '',
                        exclusively_id: '',
                        field: '',
                        hanshuisummoney: '',
                        isfillin: '',
                        issue_part_flow: '',
                        moving_pos: '',
                        qushuisummoney: '',
                        remark: '',
                        sale_issue_type: '',
                        salesman: '',
                        shuisummoney: '',
                        status: '',
                        statusname: '生成',
                        tax_code: '',
                        tax_rate: '',
                        transport_type: '',
                        update_person: '',
                        update_time: '',
                        Address_ShortName_Id:'',
                        Address_ShortName:'',
                        pro_dept:'',
                        after_flag: 0,
                        baseprice_flag: 0,
                    }
                };
                this.editvisi = true;
                that.code = ''
                this.editf = true;
                that.oldFormInline = JSON.stringify(that.formInline)
                this.authority();
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SALCOHeaderViewInfo');
            },
            // 刷新
            reflash() {
                /*this.intidata();
                let code = this.formInline.Head.exclusively_id;

                if (!this.$limits.fnIsEmpty(code)) {
                    this.getdlist(code);
                }
                else{
                    this.add();
                }*/
                let that = this;
                let datacopy = that.formInline
                for (let i = 0; i < datacopy.CoLists.length; i++) {
                    delete datacopy.CoLists[i]['index']
                    delete datacopy.CoLists[i]['_XID']
                }
                if (that.oldFormInline != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            this.intidata();
                            let code = this.formInline.Head.exclusively_id;

                            if (!this.$limits.fnIsEmpty(code)) {
                                this.getdlist(code);
                            }
                            else {
                                this.confirmAdd();
                            }
                        });
                } else {
                    this.intidata();
                    let code = this.formInline.Head.exclusively_id;

                    if (!this.$limits.fnIsEmpty(code)) {
                        this.getdlist(code);
                    }
                    else {
                        this.confirmAdd();
                    }
                }
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            //导出·
            exp() {
                /*let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('Sal/Order/GetSalOrderToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SALCOHeaderViewInfo",
                    fromname: that.$t('getapi[1001]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            //获取下拉数据
            getselect() {
                let that = this;
                let parm = {};
                // 客户类型
                that.$http.urlpost('/Basic/Sale/GetCustomerTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.CustomerTypeList = res.DataContent;
                    }
                });
                // 客户分组
                that.$http.urlpost('/Basic/Sale/GetCustomerGroupList', parm, function (res) {
                    if (res.Success == 1) {
                        that.CustomerGroupList = res.DataContent;
                    }
                });

                // 重要度
                that.$http.urlpost('VenderImportantSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.VenderImportant = res.DataContent;
                    }
                });
                that.$http.urlpost('CountrySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.Country = res.DataContent;
                    }
                });
                that.$http.urlpost('AreaSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.AreaS = res.DataContent;
                    }
                });
                //运输方式
                that.$http.urlpost('/Basic/Sale/GetTransportTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.TransMode = res.DataContent;
                    }
                });
                // 货币代码
                that.$http.urlpost('CurrencySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.Currency = res.DataContent;
                    }
                });
                // 付款方式
                that.$http.urlpost('PaymentWaySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.PaymentWay = res.DataContent;
                    }
                });

                // 税代码
                that.$http.urlpost('RateCodeSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.RateCode = res.DataContent;
                    }
                });
                // 结算方式
                that.$http.urlpost('DeliveryTermSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.DeliveryTerm = res.DataContent;
                    }
                });
                // 销售类别
                that.$http.urlpost('/Basic/Sale/GetSalTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.SalTypeList = res.DataContent;
                    }
                });
                //包装方式
                that.$http.urlpost('Basic/Sale/GetPuckTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Package = res.DataContent;
                    }
                });
                // 交货条款
                that.$http.urlpost('/Basic/Sale/GetDeliveryTermList', parm, function (res) {
                    if (res.Success == 1) {
                        that.DeliveryTermList = res.DataContent;
                    }
                });
            },
            // 物料的工艺存在一个可用版本
            routingtwo() {
                let that = this;
                let parm = {
                    partid: that.formInline.part_code,
                    routingid: that.formInline.Exclusively_Id,
                    routingversion: that.formInline.routing_version
                };
                that.$http.urlpost('Eng/Routings/RoutingTwoEnabledTrue', parm, function (res) {
                    if (res.Success == 1) {
                        // that.$message.success();
                    }
                });
            },
            // 从已有的订单导入
            implist() {
                this.$refs.orinput.clearInput(true);
            },
            //获取信息
            getitem(e) {
                console.log(e);
                let that = this;
                let parm = {
                    Code: e.exclusively_id
                };
                that.$http.urlpost('/Sal/Order/GetCopyOldCOBillLines', parm, function (res) {
                    if (res.Success == 1) {
                        console.log("111" + JSON.stringify(res));
                        res.DataContent.forEach((item, index) => {
                            // const ress = that.formInline.CoLists.some(items => {
                            // 	return items.cuspart_id == item.cuspart_id;
                            // });
                            let dataDetailLineNo = 1
                            for (let i = 0; i < that.formInline.CoLists.length; i++) {
                                if (that.formInline.CoLists[i].line_no >= dataDetailLineNo) {
                                    dataDetailLineNo = that.formInline.CoLists[i].line_no + 1
                                }
                            }
                            // if (ress) {
                            // 	console.log("222"+JSON.stringify(ress));

                            // 	that.$message.error(that.$t('getapi[2749]'));
                            // } else {
                            item.line_no = dataDetailLineNo;
                            item.add = true;
                            item.linid = index;
                            that.formInline.CoLists.push(item);
                            /*that.$set(that.formInline);
                            setTimeout(() => {
                                item.$index = that.formInline.CoLists.length - 1;
                                that.detailSum(item, 0);
                            }, 100);*/
                            // }
                        });
                    }
                });
            },
            vislinetap(){
                let that = this;
                that.visLineCloseReason=true;
            },
            // 明细菜单行操作
            linetap(type) {
                let that = this;
                let linid = that.lineid;
                let lindss = [];
                if (linid.length > 0) {
                    that.formInline.CoLists.forEach(item => {
                        let pms = {
                            exclusively_id: item.exclusively_id,
                            line_no: item.line_no,
                            status: type
                        };
                        const ress = linid.some(items => {
                            return items == item.linid;
                        });
                        if (ress) {
                            lindss.push(pms);
                        }
                    });
                    if (type == 1) {
                        that.linelist = lindss;
                        that.linetaps(1);
                    }
                    if (type == 2) {
                        that.linelist = lindss;
                        that.linetaps(2);
                    }
                    if (type == 3) {
                        that.linelist = lindss;
                        that.linetaps(3);
                    }
                    if (type == 4) {
                        
                         that.visLineCloseReason=true;
                        if(that.$limits.fnIsEmpty(that.linereason)) {
                            that.$message.error(that.$t('getapi[8768]'));//'关闭原因不能为空!'
                            return;
                        }
                        let arr = []
                        for(let i=0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                exclusively_id: that.selectData[i].exclusively_id,
                                line_no: that.selectData[i].line_no,
                                status: that.selectData[i].status
                            }]
                        }
                        let parm = {
                            exclusively_id: that.formInline.Head.exclusively_id,
                            closereason: that.linereason,
                            List: arr,
                            LangType:that.$processdata.getLang(),
                        }
                        that.$http.urlpost('/Sal/Order/SalCoDClosed', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getdlist(that.exclusively_id);
                                that.visLineCloseReason=false;
                            }
                        });
                        /*that.formInline.CoLists.forEach(item => {
                            const resss = linid.some(items => {
                                return items == item.linid;
                            });
                            if (resss) {
                                item.status = 4;
                                item.statusname = '关闭';
                                item.closereason=that.linereason;
                            }
                        });*/

                    }
                    if (type == 5) {
                        that.linelist = lindss;
                        that.linedj();
                    }
                    if (type == 6) {
                        that.linelist = lindss;
                        that.linejd();
                    }
                } else {
                    that.$message.error(that.$t('getapi[8756]'));//'请先选择行'
                }
            },
            // 行冻结
            linedj() {
                let that = this;
                let parm = {
                    List: that.linelist
                };
                that.$http.urlpost('/Sal/Order/SalCoDongJie', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[681]'));//'冻结成功'
                        that.getdlist(that.exclusively_id);
                    }
                });
            },
            // 行解冻
            linejd() {
                let that = this;
                let parm = {
                    List: that.linelist
                };
                that.$http.urlpost('/Sal/Order/SalCoJieDong', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[683]'));//'解冻成功'
                        that.getdlist(that.exclusively_id);
                    }
                });
            },
            //行操作
            linetaps(e) {
                let that = this;
                let parm = {
                    List: that.linelist
                };
                if (e == 1) {
                    that.$http.urlpost('Sal/Order/SalCoDRelease', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[4134]'));//'下达成功'
                            that.formInline.CoLists.forEach(item => {
                                if (item.line_no == that.linelist.line_no) {
                                    item.status = 1;
                                    item.statusname = '下达';
                                }
                            });
                        }
                    });
                }
                if (e == 2) {
                    that.$http.urlpost('/Sal/Order/SalCoDDelivery', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8769]'));//'部分发货成功'
                            that.formInline.CoLists.forEach(item => {
                                if (item.line_no == that.linelist.line_no) {
                                    item.status = 2;
                                    item.statusname = '部分发货';
                                }
                            });
                        }
                    });
                }
                if (e == 3) {
                    that.$http.urlpost('/Sal/Order/SalCoDAllDelivery', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8770]'));//'全部发货成功'
                            that.formInline.CoLists.forEach(item => {
                                if (item.line_no == that.linelist.line_no) {
                                    item.status = 3;
                                    item.statusname = '全部发货';
                                }
                            });
                        }
                    });
                }
            },
            // 核准下达
            audit(){
              let that = this
              let parm = {
                  exclusively_id: that.formInline.Head.exclusively_id,
                  update_time: that.formInline.Head.update_time,
                  Director_Flag: that.formInline.Head.Director_Flag == 1?0:1
              }
                that.$http.urlpost('/Sal/Order/SalCoDirectorAudit', parm, function (rst) {
                    if (rst.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(rst.Msg));
                        that.getdlist(that.formInline.Head.exclusively_id);
                    }
                });
            },
            // 订单下达
            mini_xd() {
                let that = this;
                console.log(that.formInline);
                let p1 = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: that.formInline.Head.status
                };
                that.showloading = that.openLoading();
                that.$http.urlpost('/Sal/Order/SalCoRelease', p1, function (rst) {
                    if (rst.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(rst.Msg));
                        that.getdlist(p1.exclusively_id);
                        that.authority();

                    }
                    that.showloading.close();
                });
            },
            //取消下达
            mini_cancelxd(){
                let that = this;
                let p1 = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    update_time: that.formInline.Head.update_time,
                    customer_order: that.formInline.Head.customer_order,
                };
                that.showloading = that.openLoading();
                that.$http.urlpost('/Sal/Order/CancelSalCoRelease', p1, function (rst) {
                    if (rst.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(rst.Msg));
                        that.getdlist(p1.exclusively_id);
                        that.authority();

                    }
                    that.showloading.close();
                });
            },
            vismini_qrgb(){
                let that = this;
                that.visCloseReason=true;
            },            
            mini_qrgb() {
                // 确认关闭
                let that = this;
                that.visCloseReason=true;
                if(that.$limits.fnIsEmpty(that.reason)) {
                    that.$message.error(that.$t('getapi[8768]'));//'关闭原因不能为空!'
                    return;
                }
                let p1 = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: that.formInline.Head.status,
                    closereason:that.reason
                };
                that.showloading = that.openLoading();
                that.$http.urlpost('/Sal/Order/SalCoColse', p1, function (rst) {
                    if (rst.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(rst.Msg));
                        that.getdlist(p1.exclusively_id);
                        that.authority();
                    }
                    that.showloading.close();
                    that.visCloseReason=false;
                });
            },
            //强制方法
            force(e) {
                let that = this;
                // console.log(that.formInline);
                let p1 = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: 0
                };
                if (e == 0) {
                    that.$http.urlpost('/Sal/Order/SalCoForceBuildStatus', p1, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8771]'));//'生成成功'
                        }
                    });
                }
                if (e == 1) {
                    p1.status = 2;
                    that.$http.urlpost('/Sal/Order/SalCoForcePDeliveryStatus', p1, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8772]'));//'发货成功'
                        }
                    });
                }
                if (e == 2) {
                    p1.status = 3;
                    that.$http.urlpost('/Sal/Order/SalCoForceAllDeliveryStatus', p1, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8772]'));//'发货成功'
                        }
                    });
                }
                that.getdlist(that.formInline.Head.exclusively_id);
            },
            //点击触发详情
            edits(jsd) {
                let that = this;
                if(that.code == jsd.Exclusively_Id){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 104, 1)){
                        return
                    }
                    let datacopy = that.formInline
                    for (let i = 0; i < datacopy.CoLists.length; i++) {
                        delete datacopy.CoLists[i]['index']
                        delete datacopy.CoLists[i]['_XID']
                    }
                    if (that.oldFormInline != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.oldSelectIndex = that.act
                                that.iscontinuedblclick = true
                                that.code = jsd.Exclusively_Id
                                that.oldrow = jsd
                                that.editvisi = true;
                                that.editf = false;
                                that.getdlist(jsd.Exclusively_Id)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                            });
                    } else {
                        that.oldSelectIndex = that.act
                        that.iscontinuedblclick = true
                        that.code = jsd.Exclusively_Id
                        that.oldrow = jsd
                        that.editvisi = true;
                        that.editf = false;
                        that.getdlist(jsd.Exclusively_Id)
                    }
                }, 100);
            },
            // 详情多选
            linedelsel({ records }) {
                let that = this;
                console.log(records);
                that.lineid = [];
                that.selectData = [];
                for (var i = 0; i < records.length; i++) {
                    that.lineid.push(records[i].linid);
                }
                for (let i = 0; i < records.length; i++) {
                    that.selectData.push(records[i]);
                }
                that.btnauthority();
            },
            //订单明细删除
            dellines_list() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.formInline.Head.exclusively_id,
                            status: that.formInline.Head.status,
                            customer_order: that.formInline.Head.customer_order,
                            Lists: []
                        };
                        for (let i = 0; i < that.selectData.length; i++) {
                            that.formInline.CoLists.splice(that.selectData[i].index, 1);
                            if (!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)) {
                                let datatmp = {
                                    exclusively_id: that.selectData[i].exclusively_id,
                                    line_no: that.selectData[i].line_no,
                                    sales_part: that.selectData[i].sales_part,
                                    part_version: that.selectData[i].part_version,
                                    sales_qty: that.selectData[i].sales_qty
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        // 数量减少判断是否还处于批量价格
                        let pricearr = []
                        for(let j=0;j<that.formInline.CoLists.length;j++){
                            for(let k=0;k<that.selectData.length;k++){
                                if(that.selectData[k].sales_part == that.formInline.CoLists[j].sales_part && that.formInline.CoLists[j].statusname == '生成'){
                                    pricearr.push(that.formInline.CoLists[j])
                                }
                            }
                        }
                        for(let k = 0;k<pricearr.length;k++){
                            let data = {
                                sale_Part_Code: pricearr[k].sales_part,
                                sale_Part_Version: pricearr[k].part_version,
                                customer_Code: that.formInline.Head.customer_id
                            }
                            that.$http.urlpost('/Sal/Order/IsExistSAL_Quotation', data, function (res) {
                                if (res.Success == 1 && res.DataContent.Table1[0].result == 2) {
                                    let sales_part = pricearr[k].sales_part
                                    let qty = 0
                                    for(let j =0;j< that.formInline.CoLists.length;j++){
                                        if (that.formInline.CoLists[j].sales_part == sales_part && that.formInline.CoLists[j].statusname == '生成') {
                                            qty = qty + parseFloat(that.formInline.CoLists[j].sales_qty)
                                        }
                                    }
                                    for (let i = 0; i < that.formInline.CoLists.length; i++) {
                                        if (that.formInline.CoLists[i].sales_part == sales_part && that.formInline.CoLists[i].statusname == '生成') {
                                            let parm = {
                                                sales_part_ID: that.formInline.CoLists[i].sales_part_id,
                                                currencyCode: that.formInline.Head.currency_code_id,
                                                qty: qty,
                                                customerCode: that.formInline.Head.customer_id
                                            }
                                            that.$http.urlpost('/Sal/Order/getSalPartNetPrice', parm, function (res1) {
                                                if (res1.Success == 1) {
                                                    that.formInline.CoLists[i].price_withtax = res1.DataContent.Line[0].price
                                                    that.formInline.CoLists[i].price_net = res1.DataContent.Line[0].net_price
                                                }
                                            });
                                        }
                                    }
                                }
                            });
                        }
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Sal/Order/DelSalOrderDetail', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getdlist(res.UniqueNum);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 其他
            linedelsels(e) {
                console.log(e);
                this.lineids = [];
                for (var i = 0; i < e.length; i++) {
                    this.lineids.push(e[i]);
                }
                this.btnauthority();
            },
            //批量删除
            dellines_lists() {
                let that = this;
                console.log("其它删除数据行：" + that.lineids.length);
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.formInline.Head.exclusively_id,
                            status: that.formInline.Head.status,
                            customer_order: that.formInline.Head.customer_order,
                            Lists: []
                        };

                        for (let i = 0; i < that.lineids.length; i++) {
                            that.formInline.CostLists.splice(that.lineids[i].index, 1);
                            if (!that.$limits.fnIsEmpty(that.lineids[i].exclusively_id)) {
                                let datatmp = {
                                    exclusively_id: that.lineids[i].exclusively_id,
                                    line_no: that.lineids[i].line_no
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Sal/Order/DelSalOrderOtherDetail', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getdlist(res.UniqueNum);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },

            //拖动条中间快捷按钮
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            //点击键盘触发
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            //按住键盘触发
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            //更新表格行状态
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    console.log(val, this.datajson);
                    let result = this.datajson.findIndex(item => item.Exclusively_Id === val.ExClusively_Id);
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            sortChange({ column, property, order }) {
                this.sortRule.order = order;
                this.sortRule.property = property;
            },
            // T通过地址简称获取交货信息详情信息
            getShortNameInfo(val){
                let that = this
                let parm = {
                    Customer_ID: that.formInline.Head.customer_id,
                    Exclusively_ID: val
                }
                that.$http.urlpost('/Sal/Order/GetSALCustomerInfoCOByAddrShortName', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent[0]){
                            that.formInline.Head.delivery_term = res.DataContent[0].delivery_term_name
                            that.formInline.Head.transport_type = res.DataContent[0].transport_type_name
                            that.formInline.Head.delivery_contract = res.DataContent[0].Delivery_Contract
                            that.formInline.Head.delivery_phone = res.DataContent[0].Delivery_Phone
                            that.formInline.Head.delivery_leadtime = res.DataContent[0].Delivery_Leadtime
                            that.formInline.Head.delivery_address = res.DataContent[0].Delivery_Address
                            that.formInline.Head.remark = res.DataContent[0].Remark
                        }
                    }
                });
            },
            expStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[1488]')//'下达'
                } else if(val == 2){
                    return that.$t('getapi[2708]')//'部分发货'
                } else if(val == 3){
                    return that.$t('getapi[2709]')//'完成发货'
                } else if(val == 4){
                    return that.$t('getapi[441]')//'关闭'
                } else {
                    return ''
                }
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 104,1) < 1){
                    return false
                }
                let datacopy = that.formInline
                for (let i = 0; i < datacopy.CoLists.length; i++) {
                    delete datacopy.CoLists[i]['index']
                    delete datacopy.CoLists[i]['_XID']
                }
                let flag = that.oldFormInline != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-dropdown {
        vertical-align: top;
        background-color: #ffd04b !important;
        border-color: #ffd04b !important;
        color: #ffffff;
        margin-left: 20px;
        padding: 0 14px;
        border-radius: 5px;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto;
            white-space: pre;
            span {
                margin-left: 10px;
                margin-right: 5px;
                width: 70px;
                text-align: right;
                line-height: 35px;
                display: inline-block;
            }
        }
    }

    span.titles {
        margin-left: 14px;
        margin-right: 15px;
        text-align: left;
        line-height: 40px;
        display: inline-block;
    }
    /deep/ .green {
        background: #c8ffbb;
    }
    .box .bbl span{
        line-height: 28px;
    }
</style>
